<template>
    <div>
        <Header :showupgrade="showupgrade" @closePricingPop="closePricingPop"/>
        <div class="uploadBox" v-show="isUpload"  @dragover="fileDragover" @drop="fileDrop">
            <!-- <img src="../assets/upload.svg" alt="Upload"> -->
            <svg-icon icon-class="upload" class-name="upload-svg" alt="Upload"/>
            <label for="upload">{{$t('btn.upload_image')}}</label>
            <p class="info">{{$t('content.drop')}}</p>
        </div>
        <div class="mobiletop" v-show="!isUpload">
            <span v-if="list_open">
                <a href="#section-1">
                    <!-- <img class="icon-list-open" src="../assets/list-open.svg" alt="Icon" @click="openList"> -->
                    <svg-icon icon-class="list-open" class-name="icon-list-open" alt="Icon" @click="openList"/>
                </a>
            </span>
            <span v-else>
                <!-- <a :href="'#imgli-'+selectImgId"> -->
                    <!-- <img class="icon-list-open" src="../assets/list-close.svg" alt="Icon" @click="closeList"> -->
                    <svg-icon icon-class="list-close" class-name="icon-list-open" alt="Icon" @click="closeList"/>
                <!-- </a> -->
            </span>
            <label for="upload">
                <!-- <img class="icon-mobile-add" src="../assets/mobile-add.svg" alt="Icon" > -->
                <svg-icon icon-class="mobile-add" class-name="icon-mobile-add" alt="Icon" @click="closeList"/>
            </label>
            <label for="upload">{{$t('btn.new_image')}}</label>
        </div>
        <div class="editor flex_box" v-show="!isUpload">
            
            <div class="left">
                <label for="upload">
                    <!-- <i></i> -->
                    <svg-icon icon-class="add" class-name="add-svg"/>
                {{$t('btn.new_image')}}</label>
                <div>
                    <div v-if="isnull" style="text-align:center;font-size:14px;color: #454545;">
                        <!-- <img src="../assets/pic_empty.svg" style="margin: 48px auto 10px;"/> -->
                        <svg-icon icon-class="pic_empty" class-name="pic_empty-svg"  style="margin: 48px auto 10px;"/>
                        {{$t('content.empty')}}~
                    </div>
                    <ul v-else>
                        <a href="#section-1"><li v-for="(img,index) in imgArr" :data-id="index" :key="index" v-show="img.state!='hide'" @click.stop="imgCheckClick(index)" :name="'imgli-'+index">
                            <span v-show="img.state=='completed'" class="state completed">
                                <!-- <i></i> -->
                                <svg-icon icon-class="completed" class-name="completed-svg"/>
                                <span>{{$t('content.completed')}}</span>
                            </span>
                            <span v-show="img.state=='upload'" class="state upload">
                                <!-- <i></i> -->
                                <svg-icon icon-class="uploading" class-name="uploading-svg"/>
                                <span>{{$t('content.uploading')}}</span>
                            </span>
                            <span v-show="img.state=='processing'" class="state processing">
                                <!-- <i></i> -->
                                <svg-icon icon-class="processing" class-name="processing-svg"/>
                                <span>{{$t('content.processing')}}</span>
                            </span>
                            <span v-show="img.state=='error'||img.state=='changeResolutionError'" class="state failed">
                                <!-- <i></i> -->
                                <svg-icon icon-class="failed" class-name="failed-svg"/>
                                <span>{{$t('content.failed')}}</span>
                            </span>
                            <span v-show="img.state=='waiting'" class="state waiting">
                                <!-- <i></i> -->
                                <svg-icon icon-class="waiting" class-name="waiting-svg"/>
                                <span>{{$t('content.waiting')}}</span>
                            </span>
                            <div class="img" :style="{backgroundImage:'url('+img.url+')'}"></div>
                            <!-- <div class="img">
                                <img :src="img.url"/>
                            </div> -->
                            
                            <div class="li-right">
                                <!-- <i v-show="img.state!='completed'&&img.state!='processing'"  :style="img.state=='waiting'||img.state=='error'||img.state=='upload'?'top:35px;':''" @click.stop="closeImg(img.id)" class="close" :title="$t('btn.cancel_btn')"></i> -->
                                <svg-icon v-show="img.state!='completed'&&img.state!='processing'&&img.state!='upload'"  :style="img.state=='waiting'||img.state=='error'||img.state=='upload'?'top:35px;':''" @click.stop="closeImg(index)"  icon-class="close" class-name="close-svg close" :title="$t('btn.cancel_btn')"/>
                                <!-- <i v-show="img.state=='completed'&&img.state!='processing'" class="down"  @click.stop="downloadFile(img.id)" :title="$t('btn.download')"></i> -->
                                <svg-icon  v-show="img.state=='completed'&&img.state!='processing'"  icon-class="down" class-name="down-svg down" @click.stop="downloadFile(index)" :title="$t('btn.download')"/>
                                <!-- <i v-show="img.state!='processing'&&img.state!='waiting'&&img.state!='error'&&img.state!='upload'" class="delect" @click.stop="closeImg(img.id)" :title="$t('btn.delete')"></i> -->
                                <svg-icon v-show="img.state!='processing'&&img.state!='waiting'&&img.state!='error'&&img.state!='upload'" icon-class="delect" class-name="delect-svg delect" @click.stop="closeImg(index)" :title="$t('btn.delete')"/>
                            </div>
                        </li></a>
                    </ul>
                </div>
            </div>
            <div class="right show" id="section-1">
                 <!-- :style="!multipleshow?'display: flex;justify-content: flex-end;':''" -->
                <div class="top flex_box">
                     <!-- v-show="multipleshow" -->
                    <div class="multiple">
                        <span>{{$t('content.magnification')}}</span>
                        <span :class="multiple==2?'multiple_num active':'multiple_num'" @click="changeResolutionPop(2)">2x</span>
                        <span :class="multiple==4?'multiple_num active':'multiple_num'" @click="changeResolutionPop(4)">4x</span>
                        <span :class="multiple==6?'multiple_num active':'multiple_num'" @click="changeResolutionPop(6)">6x</span>
                        <span :class="multiple==8?'multiple_num active':'multiple_num'" @click="changeResolutionPop(8)">8x</span>
                    </div>
                    <div class="btn">
                        <span @click="downloadFilePop">{{$t('btn.save_all')}}</span>
                        <span v-if="savestate=='del'" @click="closeImg(selectImgId)">{{$t('btn.delete')}}</span>
                        <!-- <span :class="!isdel?'save-cancel':''" v-if="savestate=='del'" disabel @click="isdel?delectImg(selectImgId):''">{{isdel?'删除':'删除中'}}</span> -->
                        <span :class="!isdel?'save-cancel':''" v-else-if="savestate=='cancel'" disabel @click="isdel?delectImg(selectImgId):''">{{isdel?$t('btn.cancel_btn'):$t('btn.cancel')}}</span>
                        <span v-else @click="downloadFile('one')">{{$t('btn.save')}}</span>
                    </div>
                </div>
                <div class="img_box flex_box">
                    <div class="left" ref="leftBox" v-show="isshow">
                        <div :style="{width:imgBoxMaxWidth+'px',height:imgBoxMaxHeight+'px'}" >
                            <img :src="leftImgUrl" alt="" class="imgbg">
                            <div v-show="isMask" class="mask" ref="mask"></div>
                            <div v-show="isMask" class="preview" :style="{backgroundImage:'url('+leftImgUrl+')'}" ref="preview"></div>
                            <div class="imgMask" @mouseenter="isMask=true" @mousemove="magnifier" @mouseleave="isMask=false"></div>
                        </div>
                    </div>
                    <i v-show="isshow"></i>
                    <div class="right" ref="rightBox" :style="isshow?'':'width:99%'">
                        <div :style="imgState=='completed'?{width:imgBoxMaxWidth+'px',height:imgBoxMaxHeight+'px'}:'width: 100%;height: 100%;'">
                            <img v-show="imgState=='completed'" :src="rightImgUrl" alt=""  class="imgbg">
                            <div v-show="isMask" class="mask" ref="rightMask"></div>
                            <div v-show="isMask" class="preview" :style="{backgroundImage:'url('+rightImgUrl+')'}" ref="rightPreview"></div>
                            <div class="imgMask" @mouseenter="isMask=true" @mousemove="magnifier" @mouseleave="isMask=false"></div>
                            <div class="tips" v-show="imgState!='completed'">
                                <!-- ../assets/processing-b.svg -->
                                <img v-show="imgState=='processing'" :src="processinggif" alt="Processing">
                                <p v-show="imgState=='processing'">{{$t('content.img_processing')}}</p>
                                <img v-show="imgState=='rendering'" :src="processinggif" alt="Processing">
                                <p v-show="imgState=='rendering'">
                                    {{$t('content.img_rendering1')}}</br>
                                    {{$t('content.img_rendering2')}}
                                </p>
                                <img v-show="imgState=='upload'" :src="uploadgif" alt="Upload">
                                <p v-show="imgState=='upload'">{{$t('content.img_uploading')}}</p>
                                <img v-show="imgState=='waiting'" :src="waitinggif" alt="Waiting">
                                <p v-show="imgState=='waiting'">{{$t('content.wait_upoading')}}</p>
                                <!-- <img v-show="imgState=='error' || imgState=='changeResolutionError'" src="../assets/error.svg" alt="Error"> -->
                                <svg-icon v-show="imgState=='error' || imgState=='changeResolutionError'" icon-class="error" class-name="error-svg" alt="Error"/>
                                <p v-show="imgState=='error' || imgState=='changeResolutionError'">{{$t('content.img_failed')}}</p>
                            </div>
                        </div>
                        <p class="no_watermark" v-show="imgState=='completed'" style="">{{$t('content.no_watermark')}}</p>
                    </div>
                    
                </div>
                 <!-- flex_box -->
                <div class="bottom">
                    <span style="display: flex;width: 49.5%;float: left;justify-content: center;">{{$t('content.original')}} {{OriginalSize}}</span>
                    <!-- <i @click="changeImg" :title="comparison_title" style="float:left"></i> -->
                    <svg-icon icon-class="img-change" class-name="img-change-svg" @click="changeImg" :title="comparison_title" style="float:left"/>
                    <span style="float:right;width:49%;text-align: center;display: flex; justify-content: center;">
                        <span style="font-size: 16px;font-weight: 400;color: #2473E8;line-height: 28px;"></span>
                        <span style="float:right;">{{$t('content.output')}} {{OutputSize}}</span>
                    </span>
                </div>
                <div class="right-bottom">
                    <p @click="previous">
                        <!-- <img src="../assets/previous.svg"/> -->
                        <svg-icon icon-class="previous" class-name="previous-svg"/>
                        {{$t('btn.previous')}}
                        
                    </p>
                    <p @click="next">{{$t('btn.next')}}
                        <svg-icon icon-class="previous" class-name="previous-svg" style="transform: rotate(180deg);"/>
                        <!-- <img src="../assets/previous.svg" style="transform: rotate(180deg);"/> -->
                    </p>
                </div>
            </div>
        </div>
        <div class="mobilebottom">
            <div class="left">
                <!-- <img src="../assets/upgrade-s.svg" @click="upgrade"/> -->
                <svg-icon icon-class="upgrade-s" class-name="upgrade-s-svg"  @click="upgrade"/>
                <span class="header">
                    <!-- <img src="../assets/history.svg" class="history"/> -->
                      <!-- @click.stop="upgrade" -->
                    <svg-icon icon-class="history" class-name="history-svg history"/>
                </span>
            </div>
            <div class="right" v-show="!isUpload">
                <span @click="downloadFilePop">Save All</span>
                <span :class="list_open?'save show':'save'" v-if="savestate=='del'" @click="closeImg(selectImgId)">{{$t('btn.delete')}}</span>
                <span :class="list_open?'save show':!isdel?'save-cancel':'save'" v-else-if="savestate=='cancel'" @click="isdel?delectImg(selectImgId):''">{{isdel?$t('btn.cancel_btn'):$t('btn.cancel')}}</span>
                <span :class="list_open?'save show':'save'" v-else @click="downloadFile('one')">{{$t('btn.save')}}</span>
            </div>
        </div>
        <input ref="inputFiles" type="file" id="upload" style="display:none;" @change="upload($event)" accept=".jpg, .jpeg, .png, .bmp" multiple>
        <Member/>
        <div class="maskTips" v-show="isMaskTip">
            <div>
                <!-- <i class="close" @click="errorListClose"></i> -->
                <svg-icon icon-class="close-m" class-name="close-m-svg close" @click="errorListClose"/>
                <!-- <img src="../assets/tip.svg" alt="Tip"> -->
                <svg-icon icon-class="tip" class-name="tip-svg" alt="Tip"/>
                <p class="errorListInfo"></p>
                <div class="errorList">
                    <div><span>{{$t('tips.title')}}</span><span>{{$t('tips.reasons')}}</span></div>
                    <div v-for="(img) in temporary_imgArr" :data-id="img.id" :key="img.id" v-show="img.error!=0">
                        <div class="left">
                            <i class="img" :style="{backgroundImage:'url('+img.url+')'}"  v-show="img.error!=4"></i>
                            <span>{{img.name}}</span>
                        </div>
                        <span v-show="img.error==1 || img.error==4">{{$t("tips.upload_type")}}</span>
                        <span v-show="img.error==2">{{$t("tips.max")}}</span>
                        <span v-show="img.error==3">{{$t('tips.max_size')}}</span>
                    </div>
                </div>
                <span class="btn btn_v1 errorListBtn_v1" @click="continueHandle">{{$t('btn.tips_continue_dispose')}}</span>
                <span class="btn btn_v2" @click="errorListUpload">{{$t('btn.tips_return')}}</span>
            </div>
        </div>
        <div class="maskTips" v-show="isUpgradeTip">
            <div  style="max-width: 500px;">
                <!-- <i class="close" @click="isUpgradeTipClose"></i> -->
                <svg-icon icon-class="close-m" class-name="close-m-svg close" @click="isUpgradeTipClose"/>
                <!-- <img src="../assets/tip.svg" alt="Tip"> -->
                <svg-icon icon-class="tip" class-name="tip-svg" alt="Tip"/>
                <!-- <p class="errorListInfo"></p> -->
                <div class="errorList" style="text-align: center;">
                    <!-- 剩余<span style="color:#2473E8">{{imgArr.length-downloadId}}</span>张未下载， -->
                    {{$t('tips.used_up')}}
                </div>
                <span class="btn btn_v1 errorListBtn_v1" @click="upgrade">{{$t('btn.tips_upgrade')}}</span>
                <span class="btn btn_v2" @click="downloadFile('watermark')"  style="color:#2473E8">{{$t('btn.continue_download')}}</span>
            </div>
        </div>
        <div class="maskTips" v-show="isUploadTip">
            <div  style="max-width: 500px;">
                <!-- <i class="close" @click="isUploadTipClose"></i> -->
                <svg-icon icon-class="close-m" class-name="close-m-svg close" @click="isUploadTipClose"/>
                <!-- <img src="../assets/tip.svg" alt="Tip"> -->
                <svg-icon icon-class="tip" class-name="tip-svg" alt="Tip"/>
                <!-- <p class="errorListInfo"></p> -->
                <div class="errorList" style="text-align: center;">
                   {{$t("tips.please_upgrade")}}
                </div>
                <span class="btn btn_v1 errorListBtn_v1" @click="upgrade">{{$t('btn.tips_upgrade')}}</span>
                <span class="btn btn_v2" @click="errorListUpload"  style="color:#2473E8">{{$t("btn.tips_reelect_btn")}}</span>
            </div>
        </div>
        <div class="maskTips" v-show="isChangeResolutionTip">
            <div  style="max-width: 500px;">
                <!-- <i class="close" @click="isChangeResolutionClose"></i> -->
                <svg-icon icon-class="close-m" class-name="close-m-svg close" @click="isChangeResolutionClose"/>
                <!-- <img src="../assets/tip.svg" alt="Tip"> -->
                <svg-icon icon-class="tip" class-name="tip-svg" alt="Tip"/>
                <!-- <p class="errorListInfo"></p> -->
                <div class="errorList" style="text-align: center;">
                   {{$t('tips.edit_multiple')}}
                </div>
                <!-- <span class="btn btn_v1 errorListBtn_v1" @click="">仅应用当前</span> -->
                <span class="btn btn_v2" @click="changeResolutionPresent(selectImgId,1)"  style="color:#2473E8">{{$t('btn.present')}}</span>
                <span class="btn btn_v2" @click="changeResolutionWaiting"  style="color:#2473E8">{{$t('btn.all_wait')}}</span>
                <span class="btn btn_v2" @click="changeResolutionAll"  style="color:#2473E8">{{$t('btn.all')}}</span>
                <span class="btn btn_v2" @click="isChangeResolutionClose"  style="color:#2473E8">{{$t('btn.cancel_btn')}}</span>
            </div>
        </div>
        <div class="maskTips" v-show="isDownloadFileTip">
            <div style="max-width: 500px;">
                <!-- <i class="close" @click="isDownloadFileTip=false"></i> -->
                <svg-icon icon-class="close-m" class-name="close-m-svg close" @click="isDownloadFileTip=false"/>
                <!-- <img src="../assets/tip.svg" alt="Tip"> -->
                <svg-icon icon-class="tip" class-name="tip-svg" alt="Tip"/>
                <!-- <p class="errorListInfo"></p> -->
                <div class="errorList" style="text-align: center;">
                   {{$t('tips.download_confirm')}}
                </div>
                <span class="btn btn_v1 errorListBtn_v1" @click="downloadFile('all')">{{$t('btn.tips_yes')}}</span>
                <span class="btn btn_v2" @click="isDownloadFileTip=false"  style="color:#2473E8">{{$t('btn.cancel_btn')}}</span>
            </div>
        </div>

        <!-- 放大倍数 -->
        <div class="maskTips" v-show="isMultipleTip">
            <div style="max-width: 500px;">
                <div class="icon-box">
                    <!-- <img src="../assets/icon.svg" alt="Icon" /> -->
                    <svg-icon icon-class="icon" class-name="icon-svg" alt="Icon"/>
                    <div class="icon-text">{{$t('header.title')}}</div>
                </div>
                <p class="title">{{$t('tips.please_multiple')}}</p>
                <div class="errorList" style="text-align: center;border:0px;">
                   <p class="multiple">
                    <!-- <i> (SD)</i> -->
                        <span :class="multiple==2?'multiple_num active':'multiple_num'" @click="multiple=2;OutputSize=(imgArr[selectImgId].width*multiple)+'×'+(imgArr[selectImgId].height*multiple)">2x</span>
                        <!-- <i> (HD)</i> -->
                        <span :class="multiple==4?'multiple_num active':'multiple_num'" @click="multiple=4;OutputSize=(imgArr[selectImgId].width*multiple)+'×'+(imgArr[selectImgId].height*multiple)">4x</span>
                        <!-- <i> (SHD)</i> -->
                        <span :class="multiple==6?'multiple_num active':'multiple_num'" @click="multiple=6;OutputSize=(imgArr[selectImgId].width*multiple)+'×'+(imgArr[selectImgId].height*multiple)">6x</span>
                        <!-- <i> (UHD)</i> -->
                        <span :class="multiple==8?'multiple_num active':'multiple_num'" @click="multiple=8;OutputSize=(imgArr[selectImgId].width*multiple)+'×'+(imgArr[selectImgId].height*multiple)">8x</span>
                    </p>
                    <p style="margin-top: 20px;font-size: 14px;">
                        {{$t('tips.max_multiple')}}
                    </p>
                </div>
                <span class="btn btn_v1"  @click="changeMultiple(multiple)">{{$t('btn.tips_yes')}}</span>
                <!-- <a class="btn btn_v2" href="https://www.aiseesoft.com/image-upscaler/"  style="color:#2473E8">返回</a> -->
            </div>
        </div>
        <!-- save all全部未完成 -->
        <div class="maskTips" v-show="isCompletedTip">
            <div style="max-width: 500px;">
                <div class="icon-box">
                    <!-- <img src="../assets/icon.svg" alt="Icon" /> -->
                    <svg-icon icon-class="icon" class-name="icon-svg" alt="Icon"/>
                    <div class="icon-text">{{$t('header.title')}}</div>
                </div>
                <!-- <i class="close" @click="isCompletedTip=false"></i> -->
                <svg-icon icon-class="close-m" class-name="close-m-svg close" @click="isCompletedTip=false"/>
                <!-- <img src="../assets/tip.svg" alt="Tip" style="margin-top: 40px;"> -->
                <svg-icon icon-class="tip" class-name="tip-svg" alt="Tip" style="margin-top: 40px;"/>
                <p class="errorListInfo">{{$t('tips.waiting_save')}}</p>

                <span class="btn btn_v1 errorListBtn_v1"  @click="isCompletedTip=false">{{$t('btn.tips_yes')}}</span>
            </div>
        </div>
        <!-- 权益不足弹窗 -->
        <div class="maskTips" v-show="isUnderequityTip">
            <div style="width: 700px;background: #FFFFFF;box-shadow: 0px 0px 13px -4px rgba(0,0,0,0.5);border-radius: 16px 16px 16px 16px;padding: 30px 56px 42px;">
                <svg-icon icon-class="close_new" class-name="close-m-svg close" @click="isUnderequityTip=false"/>
                <svg-icon icon-class="pic_waring" alt="Tip" style="width:260px;height:110px;margin-top: 36px;"/>
                <!-- <p class="errorListInfo"></p> -->
                <div class="errorList" style="text-align: center;font-weight: 400;font-size: 16px;color: #333333;line-height: 28px;margin-top: 10px;">
                   <!-- {{$t("isUnderequityTip_msg")}} -->
                   {{isUnderequityTip_msg}}
                </div>
                <span class="btn btn_v1 errorListBtn_v1" style="line-height: 46px;min-width: 290px;height: 46px;background: #FF6C19;border-radius: 6px 6px 6px 6px;font-weight: bold;font-size: 16px;" @click="upgrade">
                    {{$t('btn_buy_now')}}
                </span>
                <span class="btn" @click="errorListUpload"  style="font-weight: 400;font-size: 16px;color: #058CFF;margin-top:14px;">
                    {{$t("btn.tips_reelect_btn")}}
                </span>
            </div>
        </div>   
        <!-- 权益用尽弹窗 -->
        <div class="maskTips" v-show="isEquityDepletionTip">
            <div style="width: 700px;background: #FFFFFF;box-shadow: 0px 0px 13px -4px rgba(0,0,0,0.5);border-radius: 16px 16px 16px 16px;padding: 30px 56px 42px;">
                <svg-icon icon-class="close_new" class-name="close-m-svg close" @click="isEquityDepletionTip=false"/>
                <svg-icon icon-class="pic_waring" alt="Tip" style="width:260px;height:110px;margin-top: 36px;"/>
                <div class="errorList" style="text-align: center;font-weight: 400;font-size: 16px;color: #333333;line-height: 28px;margin-top: 10px;">
                    
                   {{$t("isEquityDepletionTip_msg")}}
                </div>
                <span class="btn btn_v1 errorListBtn_v1" style="line-height: 46px;min-width: 290px;height: 46px;background: #FF6C19;border-radius: 6px 6px 6px 6px;font-weight: bold;font-size: 16px;" @click="upgrade">
                    {{$t('btn_buy_now')}}
                </span>
            </div>
        </div> 
    
    </div>
</template>
<script>
import utils from '@/js/utils.js';
import Header from "@/components/header"
import Member from "@/components/member"
import processing from "@/assets/processing.gif";//制作中中图片
import waitinggif from "@/assets/waiting.gif";
import uploadgif from "@/assets/upload.gif";
import { setLocalStorage } from '@/utils/auth'
import { temporaryToken,createTask,getResult,upscaleSendQueue,upscaleDownload,upscaleUploadType} from '@/api/upscale'
import JSZip from "jszip"
import FileSaver from "file-saver"
export default {
    data(){
        return {
            isdel:true,
            isCompletedTip:false,
            isCheck:false,
            isMultipleTip:false,
            list_open:true,
            // multipleshow:false,
            isDownloadFileTip:false,
            isChangeResolutionTip:false,
            savestate:'',
            processinggif:processing,
            waitinggif:waitinggif,
            uploadgif:uploadgif,
            isnull:false,
            isshow:true,
            isUploadTip:false,
            isUpgradeTip:false,
            accountHref:"",
            isUpload:true,
            imgArr:[],
            temporary_imgArr:[],
            imgID:0,
            murmur:1,
            product_id:173,
            user:"",
            subscriptions:{
                // 可以上传图片的大小
                "in_size":{
                    quota:0,
                    cost:0,
                    limit:0, //限制用户上传的图片大小
                    threshold:0,// 阈值
                    usage:0,// 用户使用的权益
                },
                // 可以上传图片的尺寸大小 图片分辨率
                "in_edge":{
                    quota:0,
                    cost:0,
                    limit:0,//图片上传的宽度和高度
                    threshold:0,// 阈值
                },
                // 是否可以进行批处理
                "out_batch":{
                    quota:0,
                },
                // 可以放大图片的倍率
                "out_scale":{
                    quota:0,
                },
                // 可以下载无水印的图片
                "out_without_watermark":{
                    quota:0,
                    cost:0
                }
            },
            online_benefits:false,//默认是false 判断有没有online权益
            OriginalSize:"",
            OutputSize:"",
            imgBoxMaxWidth:"",
            imgBoxMaxHeight:"",
            imgBoxWidth:"",
            imgBoxHeight:"",
            imgWidth:"",
            imgHeight:"",
            zoom:2,
            isMask:false,
            leftImgUrl:'',
            rightImgUrl:'',
            selectImgId:-1,
            imgState:'completed',
            // 弹出
            isMaskTip:false,
            multipleclick:2,
            multiple:2,//分辨率倍数
            scale:2,
            downloadId:0,//下载链接数组下标
            ratio:0,
            showupgrade:false,

            // imgBoxWidth1:this.$refs['leftBox'].offsetWidth,
            // screenWidth:'',//屏幕宽度
            imgArr_length:0,
            comparison_title:this.$t('btn.view_comparison'),

            pages:0,//张数
            credits:0,//点数
            isUnderequityTip:false,//权益不足
            isEquityDepletionTip:false,//权益用尽
            upload_pages:0,//选择了几张
            need_credits:0,//还需要几点

            BucketName: '',
            bucketRegion: '',
            IdentityPoolId: '',
            albumName: '',

            // 批量下载存储图片信息
            saveImgArr:[],

            // 上传图片的域名前缀
            imgDomain:"https://assets.aiseesoft.cloud/", //这个是r2的前缀
            cloudResult:null,
        }
    },
    components:{
        Header,
        Member,
    },
    computed:{
        isUnderequityTip_msg() {
            console.log(this.credits,this.upload_pages,this.need_credits,this.pages);
            if(this.credits==0){
                return this.$t('isUnderequityTip_msg2').replace("{%}", this.upload_pages)
                .replace("{%}", this.need_credits)
                .replace("{%}", this.pages)
            }else if(this.pages==0){
                return this.$t('isUnderequityTip_msg1').replace("{%}", this.upload_pages)
                .replace("{%}", this.need_credits)
                .replace("{%}", this.credits)
            }else{
                return this.$t('isUnderequityTip_msg3').replace("{%}", this.upload_pages)
                .replace("{%}", this.need_credits)
                .replace("{%}", this.credits)
                .replace("{%}", this.pages)
            }
            
        },
    },
    mounted(){
        var self=this;
        self.initgetCredentials();
        self.temporaryToken();
        
        new Promise(async ()=>{
            try {
                await upscaleUploadType().then(res=>{
                    console.log(res,445);
                        this.cloudResult = res
                    }
                )
            } catch (error) {
                console.log(error,504)
            }
        })
        this.multiple = localStorage.getItem('scale')?localStorage.getItem('scale') : 2;
        self.setLanguage();
        var user=utils.getCookie('user');
        if(user){
            this.user=JSON.parse(user)
        }
        window.addEventListener('resize',function(){
            try {
                var imgBoxWidth=self.$refs['rightBox'].offsetWidth
                var imgBoxHeight=self.$refs['rightBox'].offsetHeight
                self.imgArr[self.selectImgId].imgBoxWidth=imgBoxWidth
                self.imgArr[self.selectImgId].imgBoxHeight=imgBoxHeight
                self.imgWidth=self.imgArr[self.selectImgId].width
                self.imgHeight=self.imgArr[self.selectImgId].height
                if(imgBoxWidth<self.imgWidth||imgBoxHeight<self.imgHeight){
                    let widthRatio = (imgBoxWidth) /  self.imgWidth 
                    let HeightRatio = (imgBoxHeight) / self.imgHeight

                    let minRatio = Math.min(widthRatio, HeightRatio)
                    self.ratio = minRatio
                    // if(self.selectImgId==0){
                        self.imgBoxMaxWidth=self.imgWidth*self.ratio
                        self.imgBoxMaxHeight=self.imgHeight*self.ratio
                    // }
                }else{
                    // let widthRatio = (imgBoxWidth) /  self.imgWidth 
                    // let HeightRatio = (imgBoxHeight) / self.imgHeight

                    // let minRatio = Math.min(widthRatio, HeightRatio)
                    // self.ratio = minRatio
                    if(self.selectImgId==0){
                        self.imgBoxMaxWidth=self.imgWidth
                        self.imgBoxMaxHeight=self.imgHeight
                    }
                }
            } catch (error) {
                
            }
            
        })
        // // 图片显示大小区域
        // this.getvisitorId();
    },
    methods:{
        // 获取上传凭证
        initgetCredentials() {
            var self = this;
            var dataObj = {};
            dataObj['module_type'] = 1;//1代表超分 2去水印 3抠图
            var signRequest = new XMLHttpRequest;
            signRequest.addEventListener('load', function (e) {
                var resps = JSON.parse(e.target.responseText)
                const decoded = JSON.parse(atob(resps.data));
                self.BucketName = decoded[0];
                self.bucketRegion = decoded[1];
                self.IdentityPoolId = decoded[1] + ":" + decoded[2];
                self.albumName = decoded[3];
                AWS.config.update({
                    region: self.bucketRegion,
                    credentials: new AWS.CognitoIdentityCredentials({
                        IdentityPoolId: self.IdentityPoolId
                    })
                });
            });
            console.log(utils.urlPost('image')+cognitoIdentityUrl);
            signRequest.open('POST', process.env.VUE_APP_API_temporaryToken+"/api/cognitoIdentity", true);//process.env.VUE_APP_BASE_API+
            signRequest.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
            signRequest.send(JSON.stringify(dataObj));//JSON.stringify(dataObj)
        },
         //获取token
        async temporaryToken(){
            var self=this;
            await new Promise((resolve, reject)=>{
                var intervalSign = setInterval(() => {
                    if(murmur != 1) {
                        clearInterval(intervalSign)
                        this.murmur = murmur
                        resolve()
                    }
                }, 50)
            });
            console.log(this.murmur,murmur,'index+564');
            var user=utils.getCookie('user');
            var data={
                e_id:this.murmur,
            }
            if(user){
                this.user=JSON.parse(user)
                data={
                    e_id:this.user.e_id,
                    t_id:this.user.t_id,
                    token:this.user.token,
                }
            }
            console.log(data,602);
            var response = await temporaryToken(data)
            console.log(response,'index')
            if (response.code == 200) {
                console.log(response.data);
                // self.$store.commit('user/SET_TOKEN',response.data.token)
                setLocalStorage("P-Token", response.data.token);
            }else{
                // self.$Message.warning(response.msg);
            }
        },
        // 上传S3
        async addPhoto(num) {
            // 判断是上传R2还是S3
            
            var self = this;
            var file = self.imgArr[num].file;
            if(this.cloudResult){
                
            if(self.cloudResult.code == 200) {
                self.imgDomain = this.cloudResult.data.u
                this.$axios.post(process.env.VUE_APP_API_temporaryToken+"/v4/api/resource/sign",{
                    "e_id": this.user?this.user.e_id:this.murmur,
                    "module_type": 2, //1超分  2抠图 3去水印 4增强 5上色 6修复 7风格化 8美颜 9年龄
                    "module": {
                    "mime_type": file.type,
                    "extension": String(file.type).split("/")[1]
                    }
                }).then(res=>{
                    console.log(res,611)
                    if(res.data.code == 200) {
                        var sign_data = JSON.parse(window.atob(res.data.data))[0];
                        console.log(sign_data,614)
                        if(sign_data.isr2) {
                            // 上传R2
                            function r2_upload(){
                                fetch(sign_data.module,{
                                method: 'PUT',
                                headers: {
                                    'Content-Type': file.type, // 设定文件的 MIME 类型
                                },
                                body: file, // 将文件作为请求体发送
                                }).then(data=>{
                                        self.imgArr[num].s3url = sign_data.key;
                                        self.createUpscaleTask(num)
                                }).catch(err=>{
                                        console.log('addphoto',err);
                                        self.imgArr[num].state='error';
                                        //创建任务失败
                                        self.postImage(num+1)
                                })
                            }
                            r2_upload();
                        }else {
                            // 上传s3
                            console.log(num,self.imgArr,597)
                            const timestamp = new Date().getTime();
                            var fileName = self.murmur + "_" + timestamp + Math.random() + self.imgArr[num].name;//保证S3文件名唯一
                            var albumPhotosKey = self.albumName;//encodeURIComponent(self.albumName) + "/";
                            var photoKey = albumPhotosKey + fileName;
                            // Use S3 ManagedUpload class as it supports multipart uploads
                            var upload = new AWS.S3.ManagedUpload({
                                params: {
                                    Bucket: self.BucketName,
                                    Key: photoKey,
                                    Body: file,
                                    ContentType: file.type,
                                    CacheControl: 'public, max-age=3600'
                                }
                            });

                            var promise = upload.promise();
                            promise.then(res => {
                                
                                self.imgArr[num].s3url = photoKey;
                                self.createUpscaleTask(num)
                            },
                            function (err) {
                                console.log('addphoto',err);
                                self.imgArr[num].state='error';
                                //创建任务失败
                                self.postImage(num+1)
                            });
                        }
                    }
                })
            }
            }
            // if(cloudResult.data.isr2){
            //     // 上传R2
            //     fetch(options.sign_data.module,{
            //     method: 'PUT',
            //     headers: {
            //         'Content-Type': file.type, // 设定文件的 MIME 类型
            //     },
            //     body: file, // 将文件作为请求体发送
            //     }).then(response=>{
            //     console.log(data,212)
            //     data.s3url = options.sign_data.key;
            //     data.upload_status = 2;
            //     upload_etime = parseInt(new Date().getTime()) + parseInt(localStorage.getItem('errorTime'));
            //     imgArr.push({
            //         ...data,
            //         s3key:options.sign_data.key,
            //         file_size:file.size,
            //         name:file.name,
            //         upload_etime
            //     });
            //     createTask(parent);
            // })

            // }else {
            //     // 长传S3
            //     console.log(num,self.imgArr,597)
            //     const timestamp = new Date().getTime();
            //     var fileName = self.murmur + "_" + timestamp + Math.random() + self.imgArr[num].name;//保证S3文件名唯一
            //     var albumPhotosKey = self.albumName;//encodeURIComponent(self.albumName) + "/";
            //     var photoKey = albumPhotosKey + fileName;
            //     // Use S3 ManagedUpload class as it supports multipart uploads
            //     var upload = new AWS.S3.ManagedUpload({
            //         params: {
            //             Bucket: self.BucketName,
            //             Key: photoKey,
            //             Body: file,
            //             ContentType: file.type,
            //             CacheControl: 'public, max-age=3600'
            //         }
            //     });

            //     var promise = upload.promise();
            //     promise.then(res => {
                    
            //         self.imgArr[num].s3url = photoKey;
            //         self.createUpscaleTask(num)
            //     },
            //     function (err) {
            //         console.log('addphoto',err);
            //         self.imgArr[num].state='error';
            //         //创建任务失败
            //         self.postImage(num+1)
            //     });
            // }
        },
        //超分任务创建
        createUpscaleTask(num) {
            let self = this;
            // var params = [];
            self.imgArr[num].state = "processing";
            var data = {};
            let taskid = utils.getDocId(20);
            this.imgArr[num].taskid = taskid;
            console.log(this.imgArr,735)
            data.taskid = taskid;
            data.s3key = this.imgArr[num].s3url;
            data.width = this.imgArr[num].width;
            data.height = this.imgArr[num].height;
            data.scaleFactors = this.imgArr[num].multiple;
            data.file_size = this.imgArr[num].size;
            data.name = this.imgArr[num].name;
            // params.push(data);
            createTask({data:data,model_type: 1}).then(async (response) => {
                if (response.code == 200) {
                    //创建任务成功
                    self.sendQueue(num);

                } else {
                    self.imgArr[num].state='error';
                    //创建任务失败
                    self.postImage(num+1)
                }

            }).catch(function (error) {
                    self.imgArr[num].state='error';
                    //创建任务失败
                    self.postImage(num+1)
            });
        },
        //超分发送队列
        sendQueue(num) {
            let self = this;
            let taskids = self.imgArr[num].taskid;

            upscaleSendQueue({taskids:taskids}).then(async (response) => {
                if (response.code == 200) {
                    console.log('upscaleSendQueue');
                    self.getUpscaleResult(num);

                } else {
                    self.imgArr[num].state='error';
                    //创建任务失败
                    self.postImage(num+1)
                }

            }).catch(function (error) {
                    self.imgArr[num].state='error';
                    //创建任务失败
                    self.postImage(num+1)
            });
        },
        //超分获取结果
        getUpscaleResult(num) {
            console.log('getUpscaleResult');
            let self = this;
            let taskid = self.imgArr[num].taskid;

            getResult({taskid:taskid}).then(async (response) => {
                if (response.code != 200) {
                    //失败

                } else {
                    if(response.data.status == 3){
                        setTimeout(() => {
                            self.getUpscaleResult(num);
                        }, 1500); 
                    }else if(response.data.status == 1){
                        //成功
                        self.imgArr[num].rightUrl=this.imgDomain+response.data.result;
                        self.imgArr[num].state='completed';
                        if(self.isdel){//此判断防止完成瞬间点击取消导致多个处理中存在
                            self.postImage(num+1)
                        }
                    }else{
                        self.imgArr[num].state='error';
                        self.postImage(num+1)
                    }
                    
                }

            }).catch(function (error) {
                    self.imgArr[num].state='error';
                    //创建任务失败
                    self.postImage(num+1)
            });
        },
        //切换语言
        setLanguage() {
            var lang = utils.getLang();
            if(lang == "jp"){
                lang="ja";
            }
            i18nWaterMark.locale = lang;
            // i18n.locale = 'zh-CN';
        },
        // 上一个
        previous(e,i=0){
            var a=parseInt(i+1)
            if(this.selectImgId-a>=0){
                if(this.imgArr[this.selectImgId-a].state!='hide'){
                    this.imgCheck(this.selectImgId-a);
                }else{
                    this.previous(e,a)
                }    
            }else{
                return;
            }
        },
        // 下一个
        next(e,i=0){
            var a=parseInt(i+1)
            if(this.selectImgId+a<this.imgArr.length){
                if(this.imgArr[this.selectImgId+a].state!='hide'){
                    this.imgCheck(this.selectImgId+a);
                }else{
                    this.next(e,a)
                }    
            }else{
                return;
            }
        },
        //展示制作中
        openList(){
            $(".editor >.left").addClass("show");
            $(".editor >.right").removeClass("show");
            $(".save").removeClass("show");
            $(".editor").css("overflow",'hidden');
            this.list_open=false;
        },
        // 展示列表
        closeList(){
            $(".editor >.right").addClass("show");
            $(".save").addClass("show");
            $(".editor >.left").removeClass("show");
            $(".editor").css("overflow-y",'auto');
            this.list_open=true;
        },
        // 应用到所有
        changeResolutionAll(){
            // this.scale=this.multipleclick;
            this.imgArr.forEach((elem,i)=>{
                if(elem.state!='hide'){
                    elem.state='waiting'
                }
                this.imgArr[i].multiple=this.multipleclick
            })
            
            this.isChangeResolutionTip=false;
            for(var i=0;i<this.imgArr.length;i++){
                if(this.imgArr[i].state!='hide'){
                    this.postImage(i);
                    this.imgCheck(i);
                    break;
                }
            }
            // this.imgCheck(0);
        },
        // 
        changeMultiple(multiple){
            this.isCheck=true;
            this.scale=multiple;
            this.imgArr.forEach((elem,i)=>{
                // elem.state='waiting'
                this.imgArr[i].multiple=this.scale
            })
            this.postImage(0);
            this.isMultipleTip=false;
            for(var i=0;i<this.imgArr.length;i++){
                if(this.imgArr.state!='hide'){
                    this.imgCheck(i);
                    break;
                }
            }
            // this.imgCheck(0);
        },
        //应用于所有等待中
        changeResolutionWaiting(){
            // this.scale=this.multipleclick;
            this.isChangeResolutionTip=false;
            this.imgArr.forEach((elem,i)=>{
                if(elem.state=='waiting'){
                    this.imgArr[i].multiple=this.multipleclick;
                    // this.postImage(i);
                }
            })
            this.imgCheck(this.selectImgId);
            
        },
        //应用于当前 
        changeResolutionPresent(selectImgId,type){
            
            
            if(this.imgArr[selectImgId].state=='waiting' && type==1){
                this.isChangeResolutionTip=false;
                //  console.log("bb");
                this.imgArr[selectImgId].multiple=this.multipleclick
                this.imgCheck(selectImgId);
            }else if(this.imgArr[selectImgId].state=='upload' || this.imgArr[selectImgId].state=='processing'){//处理中
                this.isChangeResolutionTip=false;
                this.imgArr[selectImgId].state='waiting' 
                this.imgArr[selectImgId].multiple=this.multipleclick
                this.scale=this.multipleclick;
                try {
                    this.imgArr[selectImgId].ajax.abort()
                } catch (error) {
                    
                }
                setTimeout(() => {
                    this.postImage(selectImgId)
                }, 3000);
                this.imgCheck(selectImgId);
                
            }else{//已完成情况
                this.imgArr[selectImgId].state='waiting'
                // this.multiple=this.multipleclick
                this.imgArr[selectImgId].multiple=this.multipleclick
                this.OutputSize=(this.imgArr[selectImgId].width*this.multiple)+"×"+(this.imgArr[selectImgId].height*this.multiple)
                if(type==1){//禁止递归频繁关闭弹窗
                    this.isChangeResolutionTip=false;
                    this.imgCheck(selectImgId);
                }
                var count=0
                this.imgArr.forEach(elem=>{
                    // elem.state=='processing'||elem.state=='upload'||
                    if(elem.state=='error'||elem.state=='changeResolutionError'||elem.state=='completed'){
                        count++
                    }
                })
                // console.log(count);
                if(this.imgArr.length-count==1){
                    // console.log("cc",count);
                    // alert("当前1");
                    this.changeResolution(this.multipleclick,this.imgArr[selectImgId].imageMd5,this.imgArr[selectImgId].sign,selectImgId,true);
                }else{
                    // console.log("dd");
                    setTimeout(() => {
                        this.changeResolutionPresent(selectImgId,2);
                    }, 3000);
                    
                }
            }
            
            // this.changeResolution(this.multipleclick,this.imgArr[this.selectImgId].imageMd5,this.imgArr[this.selectImgId].sign,this.selectImgId,true);
            // this.isChangeResolutionTip=false;
            // this.imgCheck(this.selectImgId);
        },
        //关闭更改分辨率弹窗
        isChangeResolutionClose(){
            this.isChangeResolutionTip=false;
            this.scale=this.multiple;
        },
        //批量文件时打开更改分辨率弹窗
        changeResolutionPop(scale){
            this.isCheck=true;
            // if(scale==this.multiple){
            //     return false;
            // }
            this.multipleclick=scale;
            // if(this.imgArr.length>1){
                this.isChangeResolutionTip=true;
            // }
            // else{
            //     this.changeResolution(scale,this.imgArr[this.selectImgId].imageMd5,this.imgArr[this.selectImgId].sign,this.selectImgId);
            // }
            this.isMultipleTip=false;
        },
        upgrade(){
            this.showupgrade=true;
            this.isUpgradeTip=false;
            this.isUploadTip=false;
            this.isUnderequityTip=false; 
            this.isEquityDepletionTip=false; 
        },
        closePricingPop(){
            this.showupgrade=false;
        },
        imgCheckClick(id){
            this.imgCheck(id) 
            this.openList();
        },
        changeImg(){
            this.imgArr[this.selectImgId].isshow=!this.imgArr[this.selectImgId].isshow
            if(this.imgArr[this.selectImgId].isshow){
                this.comparison_title=this.$t('btn.view_comparison')
            }else{
                this.comparison_title=this.$t('btn.hide_comparison')
            }
            this.imgCheck(this.selectImgId) 
             
        },
        //继续处理支持的图片
        continueHandle(){
            var self=this;
            this.isMaskTip=false;
            self.isUpload=false;
            let imgArr1 = [];
            //将临时数组赋值给imgArr
            self.temporary_imgArr.forEach((elem,i)=>{
                if(elem.state!='hide'){
                    // imgArr1.push(elem)
                    self.imgArr.push(elem);
                }
                
            })
            // self.imgArr=imgArr1.map((elem,i)=>{
            //     elem.id=i;
            //     return elem;
            // });
            // self.imgArr.forEach((elem,i)=>{
            //     if(elem.error!=0){
            //         self.imgArr.splice(i, 1)
            //     }
            // })
            // console.log(self.imgArr);
            var bool;
            // alert(self.imgArr.length);
            for(var i=0;i<self.imgArr.length;i++){
                // alert(i);
                if(self.imgArr[i].state=='upload' || self.imgArr[i].state=="processing"){
                    bool=false;
                    break;
                }else{
                    bool=true;
                }
            }
            // alert(bool);
            if(bool){
                this.postImage(0);
            }
            
        },

        // // 获取设备或浏览器唯一标识
        // async getvisitorId() {
        //     const fp = await FingerprintJS.load()
        //     const result = await fp.get()
        //     const visitorId = result.visitorId
        //     this.murmur=visitorId;
        //     if(utils.isDomain()){
        //         this.murmur=this.murmur.slice(0, -2)+utils.getLang()
        //     }
        // },
        isAssetTypeAnImage(ext) {
            return [
            'png', 'jpg', 'jpeg', 'bmp', 'gif', 'webp', 'psd', 'svg', 'tiff'].
            indexOf(ext.toLowerCase()) !== -1;
        },
        // 拖拽上传
        fileDragover(e) {
            e.preventDefault()
        },
        fileDrop(e) {
            e.preventDefault()
            this.upload(e)
        },
        //获取点数权益
        async getCredits(user){
            if(user){
                user=JSON.parse(user)
                var dataCredits={
                    e_id:user.e_id,
                    t_id:user.t_id,
                    token:user.token,
                    product_id:179
                }
            }else{
                var dataCredits={
                    e_id:this.murmur,
                    product_id:179
                }
            }
            var res = await this.$axios.post(utils.urlPost('account')+'benefit/status',dataCredits);
            // .then((res)=>{
                var benefitsCredits=res.data.subscriptions;
                if(benefitsCredits.length>1){
                    for(var i=0;i<benefitsCredits.length;i++){
                        for(var j=0;j<benefitsCredits[i].benefits.length;j++){
                            if(benefitsCredits[i].benefits[j]['key']=='credit'){
                                if(benefitsCredits[i].benefits[j].upgrade && benefitsCredits[i].ts_benefit_upgrade == 0){
                                    // 说明积分没有升级
                                    this.upgradeCredits(benefitsCredits[i].id)
                                }
                            }
                            if(benefitsCredits[i].product_feature != 0){
                                if(benefitsCredits[i].benefits[j]['key'].indexOf('upscaler')>-1){
                                    this.online_benefits = true;
                                }
                            }
                        }
                    }
                }
                for(var i=0;i<benefitsCredits.length;i++){
                    for(var j = 0;j<benefitsCredits[i].benefits.length;j++){ 
                        switch(benefitsCredits[i].benefits[j].key){
                            case 'upscaler.in_size':
                                // in_size
                                if(benefitsCredits[i].benefits[j].quota*1==-1){
                                    this.subscriptions['in_size'].quota=-1
                                }else{
                                    this.subscriptions['in_size'].quota=benefitsCredits[i].benefits[j].quota*1+this.subscriptions['in_size'].quota*1
                                    this.subscriptions['in_size'].cost=benefitsCredits[i].benefits[j].cost*1+this.subscriptions['in_size'].cost*1
                                    // 如果点数的限制比张数的限制大，则取点数的限制
                                    if(benefitsCredits[i].benefits[j].limit > this.subscriptions['in_size'].limit){
                                        this.subscriptions['in_size'].limit = benefitsCredits[i].benefits[j].limit;
                                    }
                                }
                                break;
                            case 'upscaler.in_edge':
                                // in_edge
                                if(benefitsCredits[i].benefits[j].quota*1==-1){
                                    this.subscriptions['in_edge'].quota=-1
                                }else{
                                    this.subscriptions['in_edge'].quota=benefitsCredits[i].benefits[j].quota*1+this.subscriptions['in_edge'].quota*1
                                    this.subscriptions['in_edge'].cost=benefitsCredits[i].benefits[j].cost*1+this.subscriptions['in_edge'].cost*1
                                }
                                break;
                            case 'upscaler.out_batch':
                                // in_edge
                                if(benefitsCredits[i].benefits[j].quota*1==-1){
                                    this.subscriptions['out_batch'].quota=-1
                                }
                                // out_batch
                                this.subscriptions['out_batch'].quota=benefitsCredits[i].benefits[j].quota*1+this.subscriptions['out_batch'].quota*1
                                break
                            case 'upscaler.out_scale':
                                // out_scale
                                this.subscriptions['out_scale'].quota = this.subscriptions['out_scale'].quota*1>benefitsCredits[i].benefits[j].quota*1?this.subscriptions['out_scale'].quota:benefitsCredits[i].benefits[j].quota*1
                                break;
                        }
                    }
                }



                // if(subscriptions.length>1){
                //     for(var i=0;i<subscriptions.length;i++){
                //         for(var j = 0; j < subscriptions[i].benefits.length; j++) {
                //             if(subscriptions[i].benefits[j].key == "upscaler.out_batch"){
                //                 //是否可以批量
                //                 this.subscriptions["out_batch"] = parseInt(subscriptions[i].benefits[j]["quota"]);
                //             }
                //         }
                //     }
                //     var total=0;
                //     var use=0;
                    
                //     for(var i=0;i<subscriptions.length;i++){
                //         for(var j=0;j<subscriptions[i].benefits.length;j++){
                //             if(subscriptions[i].product_feature!='101'){
                //                 if(subscriptions[i].benefits[j].key == "credit"){
                //                     total+=parseInt(subscriptions[i].benefits[j].quota);
                //                     use+=parseInt(subscriptions[i].benefits[j].cost);
                //                 }
                //             }
                //         }
                //     }
                //     console.log(total,use);
                //     this.credits = total-use;//点数
                // }
            // })
        },
        // 积分升级
        upgradeCredits(benefit_id){
            $.post(
                post_url+'benefit/upgrade',{
                    e_id: JSON.parse(getCookie('user')).e_id,
                    t_id: JSON.parse(getCookie('user')).t_id,
                    token: JSON.parse(getCookie('user')).token,
                    product_id: 179,
                    subscription_id: benefit_id
                },function(data){
                switch (data.error) {
                    case 0:
                        console.log('升级成功');
                        break;
                    case 30001:
                        break;
                    case 30002:
                        break;
                    case 30003:
                        break;
                    case 30004:
                        break;
                    case 30005:
                        break;
                    case 30006:
                        break;
                    case 30007:
                        break;
                    case 30008:
                        break;
                    case 30009:
                        break;
                    case 30010:
                        break;
                    case 30011:
                        break;
                }
            })
        },
        // 上传操作
        upload(event){
            
            var user=utils.getCookie('user');
            if(user){
                this.user=JSON.parse(user)
                var data={
                    e_id:this.user.e_id,
                    t_id:this.user.t_id,
                    token:this.user.token,
                    product_id:this.product_id
                }
            }else{
                var data={
                    e_id:this.murmur,
                    product_id:this.product_id
                }
            }
            var files = event.target.files;
            if(!files){
                files=event.dataTransfer.files;
            }
            this.$axios.post(utils.urlPost('account')+'benefit/status',data).then(async (res)=>{
                // 用于确定用户最终的权益
                var benefits = res.data.subscriptions
                //判断是否有批量上传的权益
                // // if(files.length>1){
                if(benefits.length>0){
                    
                    for(var i=0;i<benefits.length;i++){
                        for(var j = 0; j < benefits[i].benefits.length; j++) {
                        switch (benefits[i].benefits[j].key) {
                            case 'out_without_watermark':
                                this.subscriptions['out_without_watermark'].quota+=benefits[i].benefits[j].quota*1
                                this.subscriptions['out_without_watermark'].cost+=benefits[i].benefits[j].cost*1
                                break;
                            case 'in_size':
                                // 如果是限制用户上传的文件大小(选取最大的)
                                if(benefits[i].benefits[j].limit > this.subscriptions['in_size'].limit){
                                    this.subscriptions['in_size'].limit = benefits[i].benefits[j].limit;
                                }
                                // 如果用户上传的图片大小的阈值，-1表示不设限制
                                if(benefits[i].benefits[j].threshold = -1){
                                    this.subscriptions['in_size'].threshold = benefits[i].benefits[j].threshold;
                                }else{
                                    this.subscriptions['in_size'].threshold = benefits[i].benefits[j].threshold;
                                }
                                this.subscriptions['in_size'].usage = benefits[i].benefits[j].usage;
                                break;
                            case 'in_edge':
                                if(benefits[i].benefits[j].quota*1==-1){
                                    this.subscriptions['in_edge'].quota=-1
                                }
                                // 如果是限制用户上传的文件大小(选取最大的)
                                if(benefits[i].benefits[j].limit > this.subscriptions['in_edge'].limit){
                                    this.subscriptions['in_edge'].limit = benefits[i].benefits[j].limit;
                                }
                                // 如果用户上传的图片大小的阈值，-1表示不设限制
                                if(benefits[i].benefits[j].threshold = -1){
                                    this.subscriptions['in_edge'].threshold = benefits[i].benefits[j].threshold;
                                }else{
                                    this.subscriptions['in_edge'].threshold = benefits[i].benefits[j].threshold;
                                }
                                break;
                            case 'out_batch':
                                if(benefits[i].benefits[j].quota*1==-1){
                                    this.subscriptions['out_batch'].quota=-1
                                }
                                // 如果是限制用户上传的文件大小(选取最大的)
                                if(benefits[i].benefits[j].quota > this.subscriptions['out_batch'].quota){
                                    this.subscriptions['out_batch'].quota = benefits[i].benefits[j].quota;
                                }
                                break;
                            }
                        }
                    }
                    var total=0;
                    var use=0;

                    console.log(total,use,this.subscriptions);
                    this.pages=parseInt(this.subscriptions['out_without_watermark'].quota) - parseInt(this.subscriptions['out_without_watermark'].cost);//张数
                    console.log(this.pages,1134)

                }
                await this.getCredits(user);
                this.credits = await this.queryCredits(user)
                console.log(this.subscriptions['out_batch'].quota,1043)
                if(this.subscriptions['out_batch'].quota>=1){//张数点数有有一个支持批量
                    if(verificationPages()){//验证权益是否足够
                        imgPush();
                    }
                    
                }else{
                    this.isUploadTip=true;                    
                }
                
                // if(out_batch_quota==1){
                //     imgPush();
                // }else{
                //     var batch = await this.getCredits(user);
                //     if(batch==1){
                //         imgPush();
                //     }else{
                //         this.isUploadTip=true;
                //     }
                    
                // }
                
            })            
            
            var self=this;
            // 验证权益是否足够
            function verificationPages(){
                //计算点数张数是否够本次制作
                let pages = self.pages + Math.floor(self.credits/2);//可以制作多少张
                let count = self.imgArr.filter(item=>item.state!='hide').length;
                console.log(count,files.length);
                self.upload_pages = files.length+count;//选择了多少张
                let all_pages = files.length+count;
                if(pages>0){
                    if(self.upload_pages<=pages){
                        return true;
                    }else{
                        self.need_credits = (self.upload_pages-pages)*2;
                        //打开权益不足弹窗
                        self.isUnderequityTip=true; 
                        return false;
                    }
                }else{
                    //打开权益已用尽弹窗
                    self.isEquityDepletionTip=true; 
                    return false;
                }
            }
            // 同步上传，防止顺序错误
            async function imgPush(){
                self.temporary_imgArr=[];
                for(var i=0;i<files.length;i++){
                    await (function(){
                        if(self.isAssetTypeAnImage(files[i].name.substring(files[i].name.lastIndexOf(".") + 1, files[i].name.length))){
                            
                            return new Promise(function(resolve){
                                var data={
                                    id:self.imgID,
                                    name:files[i].name,
                                    size:files[i].size,
                                    type:files[i].type,
                                    state:'waiting',
                                    error:0,
                                    file:files[i],
                                }
                                var fileReader  = new FileReader();
                                fileReader.readAsDataURL(files[i]);
                                
                                fileReader.onload=function(){
                                    var image=new Image()
                                    image.src=this.result
                                    data.url=this.result
                                    data.multiple=localStorage.getItem('scale')?localStorage.getItem('scale') : 2;
                                    image.onload=function(){
                                        data.width=this.width
                                        data.height=this.height
                                        data.isshow=true
                                        //如果首页上传直接存入imgArr.反之存入临时数组中
                                        // if(self.isUpload){
                                        //     self.imgArr.push(data)
                                        // }else{
                                            //所有上传首先存入临时数组中
                                            self.temporary_imgArr.push(data);
                                        // }
                                        self.OriginalSize=self.temporary_imgArr[0].width+"×"+self.temporary_imgArr[0].height
                                        self.OutputSize=(self.temporary_imgArr[0].width*2)+"×"+(self.temporary_imgArr[0].height*2)
                                        self.imgID++
                                        resolve()   
                                    }
                                }
                            })
                        }else{
                            var data={
                                id:self.imgID,
                                name:event.target.files[i].name,
                                size:event.target.files[i].size,
                                type:event.target.files[i].type,
                                state:'hide',
                                error:4,
                            }
                            self.temporary_imgArr.push(data);
                            self.imgID++
                        }
                    }())
                }
                console.log(self.subscriptions,self.temporary_imgArr);
                //判断是否存在错误
                var isError=0
                // 给图片添加是否符合要求错误 1格式不对 2大小不对 3尺寸不对
                for(var i=0;i<self.temporary_imgArr.length;i++){
                    // 判断是否为图片文件
                    if(self.temporary_imgArr[i].error==4){
                        self.temporary_imgArr[i].state='hide'
                        isError++
                        continue;
                    }
                    //已判断过第二次无需判断
                    if(self.temporary_imgArr[i].error!=0){
                        continue;
                    }
                    // 判断格式
                    if(!['jpg', 'jpeg', 'png', 'bmp'].includes(self.temporary_imgArr[i].type.split('/')[1])){
                        
                        self.temporary_imgArr[i].error=1
                        self.temporary_imgArr[i].state='hide'
                        isError++
                    }else if(self.temporary_imgArr[i].size>self.subscriptions["in_size"].limit){// 判断大小
                        self.temporary_imgArr[i].error=2
                        self.temporary_imgArr[i].state='hide'
                        isError++
                    }else if(self.temporary_imgArr[i].width >= self.subscriptions["in_edge"].limit || self.temporary_imgArr[i].height >= self.subscriptions["in_edge"].limit ){// 判断尺寸
                        self.temporary_imgArr[i].error=3
                        self.temporary_imgArr[i].state='hide'
                        isError++
                    }
                }
                if(isError){
                    var str=self.$t("tips.errorlistinfo");
                    var data=[self.temporary_imgArr.length,self.temporary_imgArr.length-isError,isError];
                
                    $('.errorListInfo').html(self.replaceAll(str,data))
                    // $('.errorListInfo').html(`当次共选择${self.temporary_imgArr.length}张图片，${self.temporary_imgArr.length-isError}张支持，${isError}张不支持，以下是不支持超分的图片：`)
                    if(self.temporary_imgArr.length==isError){
                        $('.errorListBtn_v1').hide()
                    }else{
                        $('.errorListBtn_v1').show()
                    }
                    self.isMaskTip=true
                }else{
                    //将临时数组赋值给imgArr
                    self.temporary_imgArr.forEach((elem,i)=>{
                        self.imgArr.push(elem)
                    })

                    // self.isUpload=false;
                    self.isnull=false;
                    
                    if(self.selectImgId==-1){
                        for(var i=0;i<self.imgArr.length;i++){
                            if(self.imgArr.state!='hide'){
                                self.imgCheck(i);
                                self.isUpload=false;
                                break;
                            }
                        }
                        self.postImage(0)
                    }else{
                        self.imgCheck(self.imgArr.length-(self.imgArr.length-self.imgArr_length))
                        //继续上传时保证任务一个一个进行
                        var bool=false;
                        for(var i=0;i<self.imgArr.length-(self.imgArr.length-self.imgArr_length);i++){
                            if(self.imgArr[i].state=='waiting' || self.imgArr[i].state=='upload' || self.imgArr[i].state=='processing'){
                                bool=false;
                                break;
                            }else{
                                bool=true;
                            }
                        }
                        if(self.imgArr.length-(self.imgArr.length-self.imgArr_length)==0){
                             self.postImage(self.imgArr.length-(self.imgArr.length-self.imgArr_length)+1)
                        }
                        if(bool){
                            self.postImage(self.imgArr.length-(self.imgArr.length-self.imgArr_length))
                        }
                           
                    }
                    self.imgArr_length=self.imgArr.length;
                    // self.postImage(0)
                }
                
            }
        },
        async queryCredits(user){
            if(user){
                user=JSON.parse(user)
                var dataCredits={
                    e_id:user.e_id,
                    t_id:user.t_id,
                    token:user.token,
                    product_id:179
                }
            }else{
                var dataCredits={
                    e_id:this.murmur,
                    product_id:179
                }
            }
            
            var res = await this.$axios.post(utils.urlPost('account')+'credit/status',dataCredits);
            if(res.data.error==0){
                var credits_total = 0;      
                var all_credits = res.data.credits;
                all_credits.forEach((v,i)=>{
                    if(v.name == "credit"){
                        credits_total += v.balance*1;
                    }
                })
                // var credits = total-use;
                return Math.floor(credits_total/2);
            }
        },
        //替换多语言翻译中的变量str 原字符串  data变量数组
        replaceAll(str,data) {
            var regex = new RegExp('XXX', 'g'); // 使用g表示整个字符串都要匹配
            var result = str.match(regex); //match方法可在字符串内检索指定的值，或找到一个或多个正则表达式的匹配。
            var count=!result ? 0 : result.length;//获取变量个数
            for(var i=0;i<count;i++){
                str=str.replace('XXX',data[i]);
            }
            return str;
        },
        // 清空列表重新选择
        errorListUpload(){
            //判断是首页的重新选择则清空列表
            if(this.isUpload){
                this.imgArr=[]
                this.imgID=0
                this.isnull=true;
            }
            this.isUnderequityTip=false; 
            this.isEquityDepletionTip=false; 
            this.isMaskTip=false
            this.isUploadTip=false
            $('#upload').click()
            
        },

        // 关闭弹出清空列表
        errorListClose(){
            // this.imgArr=[]
            this.isMaskTip=false
            // this.imgID=0
            // this.isnull=true;
        },
        // 关闭弹出
        isUpgradeTipClose(){
            this.isUpgradeTip=false
        },
        isUploadTipClose(){
            this.isUploadTip=false
        },
        // 接口请求处理
        postImage(num){
            if(num>=this.imgID){
                return false
            }
            var self=this;
            var imgBoxWidth=this.$refs['rightBox'].offsetWidth
            var imgBoxHeight=this.$refs['rightBox'].offsetHeight
            try {
                this.imgArr[num].imgBoxWidth=imgBoxWidth
                this.imgArr[num].imgBoxHeight=imgBoxHeight
                this.imgWidth=this.imgArr[num].width
                this.imgHeight=this.imgArr[num].height
                if(imgBoxWidth<this.imgWidth||imgBoxHeight<this.imgHeight){
                    let widthRatio = (imgBoxWidth) /  this.imgWidth 
                    let HeightRatio = (imgBoxHeight) / this.imgHeight

                    let minRatio = Math.min(widthRatio, HeightRatio)
                    this.ratio = minRatio
                    this.imgArr[num].ratio=minRatio
                    if(num==0){//防止修改倍数，画布大小错误
                        this.imgBoxMaxWidth=this.imgWidth*this.imgArr[num].ratio
                        this.imgBoxMaxHeight=this.imgHeight*this.imgArr[num].ratio
                    }
                    
                }else{
                    if(num==0){
                        this.imgBoxMaxWidth=this.imgWidth
                        this.imgBoxMaxHeight=this.imgHeight
                    }
                }
            } catch (error) {
                
            }
            
            // this.OriginalSize=this.imgWidth+"*"+this.imgHeight
            if(this.imgArr[num].state!='waiting'&&this.imgArr[num].error==0){
                this.postImage(num+1)
                return false
            }
            if(!this.isCheck){
                self.isMultipleTip=true;
                return;
            }else{
                self.isMultipleTip=false;
            }
            self.imgArr[num].state='upload'
            self.addPhoto(num);
        },
        // 接口请求处理
        postImageOld(num){
            // alert("e"+num);
            if(num>=this.imgID){
                return false
            }
            //
            // if(this.imgArr[num].state=="hide"){
            //     return false
            // }
            var self=this;
            // if(self.imgArr[num].state='hide'){//防止取消的图片继续出现在列表中
            //     self.postImage(num+1);
            //     return;
            // }
            
            var imgBlob=utils.convertBase64UrlToBlob(self.imgArr[num].url)

            console.log("imgBlob",imgBlob)
            var name=self.imgArr[num].name
            // 获取文件MD5值
             utils.getFileMd5(imgBlob,function(md5Value){
                const timestamp = new Date().getTime();
                const sign = utils.encrypt(md5Value + timestamp)
                const formData = new FormData();
                formData.append('img', imgBlob)
                formData.append('sign', sign)
                formData.append('name', name)
                self.uploadImage(formData,self.imgArr[num].multiple,md5Value,sign,num)//self.imgArr[num].id
                self.imgArr[num].imageMd5=md5Value;
                self.imgArr[num].sign=sign;
                // self.imgArr[num].multiple=self.scale
            })
        },
        // 图片上传接口
        uploadImage(formData,scale,imageMd5,sign,id){    
            // alert("w");       
            var imgBoxWidth=this.$refs['rightBox'].offsetWidth
            var imgBoxHeight=this.$refs['rightBox'].offsetHeight
            this.imgArr[id].imgBoxWidth=imgBoxWidth
            this.imgArr[id].imgBoxHeight=imgBoxHeight
            this.imgWidth=this.imgArr[id].width
            this.imgHeight=this.imgArr[id].height
            if(imgBoxWidth<this.imgWidth||imgBoxHeight<this.imgHeight){
                let widthRatio = (imgBoxWidth) /  this.imgWidth 
                let HeightRatio = (imgBoxHeight) / this.imgHeight

                let minRatio = Math.min(widthRatio, HeightRatio)
                this.ratio = minRatio
                this.imgArr[id].ratio=minRatio
                if(id==0){//防止修改倍数，画布大小错误
                    this.imgBoxMaxWidth=this.imgWidth*this.imgArr[id].ratio
                    this.imgBoxMaxHeight=this.imgHeight*this.imgArr[id].ratio
                }
                
            }else{
                if(id==0){
                    this.imgBoxMaxWidth=this.imgWidth
                    this.imgBoxMaxHeight=this.imgHeight
                }
            }
            // this.OriginalSize=this.imgWidth+"*"+this.imgHeight
            if(this.imgArr[id].state!='waiting'&&this.imgArr[id].error==0){
                this.postImage(id+1)
                return false
            }
            // alert("q");
            if(!this.isCheck){
                this.isMultipleTip=true;
                return;
            }else{
                this.isMultipleTip=false;
            }
            this.imgArr[id].state='upload'
            
            var self=this
            // return;
            this.imgArr[id].ajax=$.ajax({
                url: utils.urlPost('image')+'upload',
                type: 'post',
                cache: false,
                contentType: false,
                processData: false,
                data: formData,
                success: function(res){
                    if(res.status==200){
                        self.requestDeal(scale, imageMd5, sign,id)
                    }else{
                        self.imgArr[id].state='error'
                        self.postImage(id+1)
                        
                    }
                },
                error: function(error){
                    self.imgArr[id].state='error'
                    // self.postImage(id+1)
                    // if (error.status === 503) {   // 如果是 503 错误,等待 1 秒后重试
                        setTimeout(() => {
                            self.postImage(id+1)
                        }, 5000)
                    // }

                }
            })
        },
        // 图片请求接口
        requestDeal(scale,imageMd5,sign,id){
            
            if(this.imgArr[id].state!='upload'){
                return false
            }
            this.imgArr[id].state='processing'

            const formData = new FormData();
            formData.append('token', imageMd5)
            formData.append('scale', scale)
            if(this.user){
                formData.append('e_id', this.user.e_id)
                formData.append('t_id', this.user.t_id)
                formData.append('lToken', this.user.token)
            }else{
		        formData.append('e_id', this.murmur)
            }
            var self=this
            this.imgArr[id].ajax=$.ajax({
                url: utils.urlPost('image')+'sr',
                type: 'post',
                cache: false,
                contentType: false,
                processData: false,
                data: formData,
                success: function(res){
                    if(res.status==200){
                        self.getResult(res.key, scale, imageMd5, sign,id)
                    }else{
                        self.imgArr[id].state='error'
                        self.postImage(id+1)
                    }
                },
                error: function(error){
                    self.imgArr[id].state='error'
                    self.postImage(id+1)
                }
            })
        },
        // 图片查询结果
        getResult(code, scale, imageMd5, sign,id){
            if(this.imgArr[id].state!='processing'){
                return false
            }
            var self=this
            this.imgArr[id].ajax=$.ajax({
                url: utils.urlPost('image')+'status',
                type: 'post',
                data: {code:code},
                success: function(res){
                    if(res.status==200){
                        self.imgArr[id].state='rendering'
                        var image=new Image()
                        image.src=res.urlV
                        image.setAttribute("crossOrigin",'Anonymous')
                        self.imgArr[id].rightUrl=res.urlV;
                        self.imgArr[id].imageKey=res.key;
                        self.imgArr[id].task_id=res.task_id;
                        console.log(self.imgArr,1908)
                        (function(id,image){
                            image.onload=function(){
                                var url=utils.getBase64Image(image)
                                url=URL.createObjectURL(utils.convertBase64UrlToBlob(url))
                                self.imgArr[id].rightUrl=url;
                                self.imgArr[id].state='completed'
                                if(self.isdel){//此判断防止完成瞬间点击取消导致多个处理中存在
                                    self.postImage(id+1)
                                }
                                
                            }
                            image.onerror=function(e){
                                console.log(e,1822)
                            }
                        })(id,image)
                        // self.multipleshow=true;
                        // self.isUpgradeTip=true
                    }else if(res.status==201){
                        setTimeout(function() {
                            self.getResult(code, scale, imageMd5, sign,id)
                        }, 3000)
                    }else{
                        self.imgArr[id].state='error'
                        self.postImage(id+1)
                    }
                },
                error: function(error){
                    self.imgArr[id].state='error'
                    self.postImage(id+1)
                }
            })
            
        },
        //关闭图片
        closeImg(id){
            this.openList();//关闭列表打开右侧制作中
            this.imgArr[id].state='hide'
               
            if(this.imgArr.length>0){
                // this.imgArr.forEach(elem=>{
                var bool=false;
                for(var i=0;i<this.imgArr.length;i++){
                    if(this.imgArr[i].state!='hide'){
                        bool=true;
                        break;
                    }else{
                        bool=false;
                    }
                }
                if(bool){
                    this.isnull=false;
                }else{
                    this.isnull=true;
                    this.isUpload=true;
                    this.isCheck=false;
                    // this.imgArr=[];
                    
                }
                for(var i=0;i<this.imgArr.length;i++){
                    if(this.imgArr[id+1+i]&&this.imgArr[id+1+i].state!='hide'){
                        this.imgCheck(id+1+i);
                        break;
                    }else{
                        if(this.imgArr[id-1-i]&&this.imgArr[id-1-i].state!='hide'){
                            this.imgCheck(id-1-i);
                            break;
                        }
                    }
                }
            }else{
                this.isnull=true;
                this.isUpload=true;
                this.isCheck=false;
                // this.imgArr=[];
            }
            this.$refs.inputFiles.value = null;
            
            
        },
        // 停止图片请求
        delectImg(id){
            this.isdel=false;
            setTimeout(() => {
                this.imgArr[id].state='hide'
                try {
                    this.imgArr[id].ajax.abort()
                } catch (error) {
                    
                }
                if(this.imgArr.length>0){
                    // this.imgArr.forEach(elem=>{
                    var bool=false;
                    for(var i=0;i<this.imgArr.length;i++){
                        if(this.imgArr[i].state!='hide'){
                            bool=true;
                            //点取消的时候继续制作下一个
                            this.postImage(id+1)
                            break;
                        }else{
                            bool=false;
                        }
                    }
                    if(bool){
                        this.isnull=false;
                    }else{
                        this.isnull=true;
                        this.isUpload=true;
                        this.isCheck=false;
                        // this.imgArr=[];
                        
                    }
                    for(var i=0;i<this.imgArr.length;i++){
                        if(this.imgArr[id+1+i]&&this.imgArr[id+1+i].state!='hide'){
                            this.imgCheck(id+1+i);
                            break;
                        }else{
                            if(this.imgArr[id-1-i]&&this.imgArr[id-1-i].state!='hide'){
                                this.imgCheck(id-1-i);
                                break;
                            }
                        }
                    }
                }else{
                    this.isnull=true;
                    this.isUpload=true;
                    this.isCheck=false;
                    // this.imgArr=[];
                }
                this.$refs.inputFiles.value = null;
                
                // utils.throttle(this.postImage(this.selectImgId+1),3000);
                
                this.isdel=true;
            }, 5000);
        },
        // 左侧文件选中
        imgCheck(id){
            this.selectImgId=id
            if(this.imgArr[id].state=='waiting'||this.imgArr[id].state=='error'){
                this.savestate='del';
            }else if(this.imgArr[id].state=='processing'){
                this.savestate='cancel';
            }else{
                this.savestate='';
            }
            this.isshow=this.imgArr[id].isshow;
            this.OutputSize=(this.imgArr[id].width*this.imgArr[id].multiple)+"×"+(this.imgArr[id].height*this.imgArr[id].multiple)
        
            this.multiple=this.imgArr[id].multiple;
            var imgBoxWidth=this.$refs['rightBox'].offsetWidth
            var imgBoxHeight=this.$refs['rightBox'].offsetHeight
            if(this.imgArr[id].imgBoxWidth){
                var imgBoxWidth=this.imgArr[id].imgBoxWidth
                var imgBoxHeight=this.imgArr[id].imgBoxHeight
            }
            this.imgWidth=this.imgArr[id].width;
            this.imgHeight=this.imgArr[id].height;
            this.OriginalSize=this.imgWidth+"×"+this.imgHeight
            if(imgBoxWidth<this.imgArr[id].width||imgBoxHeight<this.imgArr[id].height){
                let widthRatio = (imgBoxWidth) /  this.imgArr[id].width
                let HeightRatio = (imgBoxHeight) / this.imgArr[id].height

                let minRatio = Math.min(widthRatio, HeightRatio)
                this.ratio = minRatio
                this.imgArr[id].ratio = minRatio
                this.imgBoxMaxWidth=this.imgArr[id].width*this.imgArr[id].ratio
                this.imgBoxMaxHeight=this.imgArr[id].height*this.imgArr[id].ratio
                
            }else{
                this.imgBoxMaxWidth=this.imgArr[id].width
                this.imgBoxMaxHeight=this.imgArr[id].height
                
            }

            this.$refs['leftBox'].children[0].children[0].style.width='100%'
            this.$refs['leftBox'].children[0].children[0].style.height='100%'

            this.leftImgUrl=URL.createObjectURL(utils.convertBase64UrlToBlob(this.imgArr[id].url))
            console.log(this.imgArr,1971)
            this.rightImgUrl=this.imgArr[id].rightUrl

            this.$refs['rightBox'].children[0].children[0].style.width='100%'
            this.$refs['rightBox'].children[0].children[0].style.height='100%'

            this.$refs['preview'].style.backgroundSize=this.imgArr[id].width*this.imgArr[id].multiple+'px'+' '+this.imgArr[id].height*this.imgArr[id].multiple+'px'
            this.$refs['rightPreview'].style.backgroundSize=this.imgArr[id].width*this.imgArr[id].multiple+'px'+' '+this.imgArr[id].height*this.imgArr[id].multiple+'px'
            this.imgState=this.imgArr[id].state
            
        },
        // 放大镜效果
        magnifier(e){
            
            // if(this.imgWidth>200 || this.imgHeight>200){
                var mask=this.$refs['mask']
                var selectRatio = this.imgWidth*this.multiple / this.imgBoxMaxWidth;
                if(this.imgWidth>this.imgBoxMaxWidth){
                    mask.style.width = 200 / selectRatio+'px';
                    mask.style.height = 200 / selectRatio+'px';
                }else{
                    mask.style.width=200/this.multiple+'px'
                    mask.style.height=200/this.multiple+'px'
                }
                var preview=this.$refs['preview']
                var left=e.offsetX-mask.offsetWidth/this.multiple
                var top=e.offsetY-mask.offsetHeight/this.multiple
                if(left<0){
                    left=0
                }
                if(left>this.imgBoxMaxWidth-parseFloat(mask.style.width)){
                    left=this.imgBoxMaxWidth-parseFloat(mask.style.width)
                }
                if(top<0){
                    top=0
                }
                if(top>this.imgBoxMaxHeight-parseFloat(mask.style.height)){
                    top=this.imgBoxMaxHeight-parseFloat(mask.style.height)
                }
                mask.style.left=left+'px'
                mask.style.top=top+'px'
                this.$refs['rightMask'].style.width=mask.style.width
                this.$refs['rightMask'].style.height=mask.style.height
                this.$refs['rightMask'].style.left=left+'px'
                this.$refs['rightMask'].style.top=top+'px'

                preview.style.left=left+'px'
                preview.style.top=top+parseFloat(mask.style.height)+'px'
                
                this.$refs['rightPreview'].style.left=left+'px'
                this.$refs['rightPreview'].style.top=top+parseFloat(mask.style.height)+'px'
                if(this.imgWidth*0.8>this.imgBoxMaxWidth){
                    preview.style.backgroundPositionX=-left*selectRatio+'px'///(this.ratio)
                    preview.style.backgroundPositionY=-top*selectRatio+'px'///(this.ratio)
                    this.$refs['rightPreview'].style.backgroundPositionX=-left*selectRatio+'px'
                    this.$refs['rightPreview'].style.backgroundPositionY=-top*selectRatio+'px'
                }else{
                    preview.style.backgroundPositionX=-(left*(200/parseFloat(mask.style.width)))+'px'///(this.ratio)
                    preview.style.backgroundPositionY=-(top*(200/parseFloat(mask.style.height)))+'px'///(this.ratio)

                    this.$refs['rightPreview'].style.backgroundPositionX=-left*(200/parseFloat(mask.style.width))+'px'
                    this.$refs['rightPreview'].style.backgroundPositionY=-top*(200/parseFloat(mask.style.height))+'px'
                }
                
            // }else{
            //     return false;
            // }
        },
        // 更改分辨率
        changeResolution(scale,imageMd5,sign,num){
            // if(this.imgArr[id].state!='completed' && this.imgArr[id].state!="changeResolutionError"){
            //     return false
            // }
            // alert("当前2");
            console.log("changeResolution",num);
            this.imgArr[num].state='processing'
            this.imgArr[num].multiple=scale;
            this.multiple=scale;
            this.createUpscaleTask(num);
        },
        // 更改分辨率
        changeResolutionOld(scale,imageMd5,sign,id){
            // if(this.imgArr[id].state!='completed' && this.imgArr[id].state!="changeResolutionError"){
            //     return false
            // }
            // alert("当前2");
            this.imgArr[id].state='processing'
            this.imgArr[id].multiple=scale;
            this.multiple=scale;
            const formData = new FormData();
            formData.append('token', imageMd5)
            formData.append('scale', scale)
            if(this.user){
                formData.append('e_id', this.user.e_id)
                formData.append('t_id', this.user.t_id)
                formData.append('lToken', this.user.token)
            }else{
		        formData.append('e_id', this.murmur)
            }
            var self=this
            this.imgArr[id].ajax=$.ajax({
                url: utils.urlPost('image')+'sr',
                type: 'post',
                async:false,
                cache: false,
                contentType: false,
                processData: false,
                data: formData,
                success: function(res){
                    if(res.status==200){
                        self.getResult(res.key, scale, imageMd5, sign,id)
                    }
                    else{
                        self.imgArr[id].state='changeResolutionError'
                        // self.postImage(id+1)
                    }
                },
                error: function(error){
                    self.imgArr[id].state='changeResolutionError'
                    // self.postImage(id+1)
                }
            })
        },
        //点击save all
        downloadFilePop(){
            // 调用之前先清空之前存储的图片信息
            this.saveImgArr=[];
            var bool=true;
            for(var i=0;i<this.imgArr.length;i++){
                if(this.imgArr[i].state=='completed'){
                    bool=false;
                    break;
                }else{
                    bool=true;
                }
            }
            if(bool){
                this.isCompletedTip=true;
                return;
            }
            for(var i=0;i<this.imgArr.length;i++){
                if(this.imgArr[i].state=='upload'||this.imgArr[i].state=='processing'||this.imgArr[i].state=='waiting'){
                    this.isDownloadFileTip=true;
                    return;
                }
            }
            this.downloadFile('all');
        },
        getImgInfo(imgUrl,fileName){
            this.saveImgArr.push({imgUrl:process.env.VUE_APP_S3_URL + imgUrl,fileName});
        },
        // 批量打包下载
       async downloadAllImg(){
            if(this.saveImgArr.length!=0){
                console.log(this.saveImgArr,"this.saveImgArr");
                const jszip = new JSZip();
                const imgFolder = jszip.folder("selected_images"); // 创建文件夹
                // 新增：记录每个文件名的出现次数，解决重名覆盖问题
                const fileNameMap = new Map();
                for (var i = 0; i < this.saveImgArr.length; i++) {
                const url = this.saveImgArr[i].imgUrl;
                const originalFileName = this.saveImgArr[i].fileName;
                
                // 新增：生成不重复的唯一文件名
                let uniqueFileName = originalFileName;
                if (fileNameMap.has(originalFileName)) {
                    // 拆分文件名和扩展名，添加序号后缀
                    const [name, ext] = originalFileName.split('.');
                    const count = fileNameMap.get(originalFileName) + 1;
                    fileNameMap.set(originalFileName, count);
                    uniqueFileName = ext ? `${name}(${count}).${ext}` : `${originalFileName}(${count})`;
                } else {
                    fileNameMap.set(originalFileName, 0);
                }

                const response = await fetch(url);
                if (!response.ok) throw new Error(`下载失败: ${url}`);
                const blob = await response.blob();
                // 修改：使用处理后的唯一文件名
                imgFolder.file(uniqueFileName, blob);
                }
                // 生成ZIP并下载
                const zipBlob = await jszip.generateAsync({ type: 'blob' });
                FileSaver.saveAs(zipBlob,"selected_images.zip");
                return true
            }
        },
        downloadFileXML(url,fileName){
            url = process.env.VUE_APP_S3_URL + url;
            //fileurl文件地址（一般是接口返回） filename文件下载后的名字
            const x = new XMLHttpRequest();
            x.open('GET', url, true);
            x.responseType = 'blob';
            x.onload = function () {
                const url = window.URL.createObjectURL(x.response);
                const a = document.createElement('a');
                a.href = url;
                a.download = fileName;
                a.click();
                // document.body.removeChild(a);
                // 然后移除
            }
            x.send()
        },
        async downloadFile(type){
            this.openList();//关闭列表打开右侧制作中
            var self=this;
            var imgArr=[];
            if(type=='all'){
                self.imgArr.forEach(elem=>{
                    if(elem.state!='hide'&&elem.state!='error'){
                        imgArr.push(elem);
                    }
                })
                // imgArr=self.imgArr;
                this.isDownloadFileTip=false;
            }else if(type=='one'){
                imgArr.push(self.imgArr[self.selectImgId]);
            }else if(type=='watermark'){
                for(var j=self.downloadId;j<self.imgArr.length;j++){
                    if(self.imgArr[j].state!='hide'&&self.imgArr[j].state!='error'){
                        imgArr.push(self.imgArr[j]);
                    }
                    // imgArr.push(self.imgArr[j])
                }
            }else{
                imgArr.push(self.imgArr[type]);
            }
            for(var i=0; i<imgArr.length;i++){
                var data={
                    // e_id:this.murmur,
                    taskids:imgArr[i].taskid,
                };
                var res = await upscaleDownload(data)
                // upscaleDownload(data).then(async (res,type) => {
                console.log("downloadFile",type,res);
                if(res.code==200){
                    self.isUpgradeTip=false
                    if(type=='all'){
                        if(imgArr[i].state!='hide'&&imgArr[i].state!='error'){
                            var fileName = (imgArr[i].name).substr(0,imgArr[i].name.lastIndexOf("."))+ "_"+imgArr[i].multiple+"×"+(imgArr[i].name).substr(imgArr[i].name.lastIndexOf("."),imgArr[i].name.length);
                            // self.downloadFileXML(res.data[0].processed_image,fileName)
                            self.getImgInfo(res.data[0].processed_image,fileName)
                        }
                    }else if(type=='one'){
                        var fileName = (imgArr[i].name).substr(0,imgArr[i].name.lastIndexOf("."))+ "_"+imgArr[i].multiple+"×"+(imgArr[i].name).substr(imgArr[i].name.lastIndexOf("."),imgArr[i].name.length);
                        self.downloadFileXML(res.data[0].processed_image,fileName)
                    }else if(type=='watermark'){
                        if(imgArr[i].state!='hide'&&imgArr[i].state!='error'){
                            var fileName = (imgArr[i].name).substr(0,imgArr[i].name.lastIndexOf("."))+ "_"+imgArr[i].multiple+"×"+(imgArr[i].name).substr(imgArr[i].name.lastIndexOf("."),imgArr[i].name.length);
                            self.downloadFileXML(res.data[0].processed_image,fileName)
                            
                        }
                    }else{
                        var fileName = (self.imgArr[type].name).substr(0,self.imgArr[type].name.lastIndexOf("."))+ "_"+self.imgArr[type].multiple+"×"+(self.imgArr[type].name).substr(self.imgArr[type].name.lastIndexOf("."),self.imgArr[type].name.length);
                        self.downloadFileXML(res.data[0].processed_image,fileName)
                    }
                }else if(res.code==50006){
                    if(type=='watermark'){
                        if(imgArr[i].state!='hide'&&imgArr[i].state!='error'){
                            var fileName = (imgArr[i].name).substr(0,imgArr[i].name.lastIndexOf("."))+ "_"+imgArr[i].multiple+"×"+(imgArr[i].name).substr(imgArr[i].name.lastIndexOf("."),imgArr[i].name.length);
                            self.downloadFileXML(res.data[0].processed_image,fileName)
                            
                        }
                    }else{
                        self.downloadId=i;
                        self.isUpgradeTip=true
                    }
                    
                }
                // }).catch((error) =>{});

                if(self.isUpgradeTip==true){
                    break;
                }
            }
            
                if(type == 'all' && this.saveImgArr.length > 0) {
                    this.downloadAllImg(); // 下载所有图片
                }
            
        },


    },
    watch:{
        imgArr:{
            handler(val,oldVal){
                try{
                    this.imgState=this.imgArr[this.selectImgId].state
                    if(val[this.selectImgId].state=='completed'){
                        this.imgCheck(this.selectImgId)
                    }
                    if(this.imgArr[this.selectImgId].state=='error'||this.imgArr[this.selectImgId].state=='waiting'){
                        this.savestate='del'
                    }else if(this.imgArr[this.selectImgId].state=='processing'||this.imgArr[this.selectImgId].state=='upload'){
                        this.savestate='cancel'
                    }else{
                        this.savestate=''
                    }
                }catch(e){
                    console.log(e)
                }
            },
            deep: true
        },
        isUpload(val){
            if(!val){
                for(var i=0;i<this.imgArr.length;i++){
                    if(this.imgArr.state!='hide'){
                        this.imgCheck(i);
                        break;
                    }
                }
                // setTimeout(() => {
                    // this.imgBoxMaxWidth=this.$refs['leftBox'].offsetWidth //*0.8
                    // this.imgBoxMaxHeight=this.$refs['leftBox'].offsetHeight  //*0.8
                    
                // }, 2000);
            }else{
                this.imgArr=[];
                this.imgID=0;
                // this.imgArr_length=0
                this.selectImgId=-1
            }
        },
        OutputSize(val){
            var sizeArr = val.split("×");
            if(sizeArr[0]>4096){
                if(sizeArr[0]>sizeArr[1]){
                    this.OutputSize='4096×'+parseInt(sizeArr[1]/(sizeArr[0]/4096));
                }else{
                    this.OutputSize=parseInt(sizeArr[0]/(sizeArr[1]/4096))+'×4096';
                }
                
            }else{
                if(sizeArr[1]>4096){
                    this.OutputSize=parseInt(sizeArr[0]/(sizeArr[1]/4096))+'×4096';
                }
            }
        },
        multiple(val){
            localStorage.setItem('scale',val)
        },
        // screenWidth(val){
        //     console.log(val)
        // },
    }
}
</script>
<style lang="scss" scoped>
    .close-m-svg{
        stroke:#6F6F6F;
        &:hover{
            stroke:#2473E8;
        }
    }
    .img-change-svg{
        width: 13px;
        height: 13px;
        cursor: pointer;
        stroke:#b4b4b4;
        color:#efeff0;
    }
    
    
    .completed-svg{
        width: 10px;
        height: 10px;
        display: inline-block;
        vertical-align: -2px!important;
        margin-right: 2px;
        color:#3cdc99;
    }
    .uploading-svg{
        width: 10px;
        height: 10px;
        display: inline-block;
        vertical-align: -2px!important;
        margin-right: 2px;
        color:white;
        stroke:#49616D;
    }
    .upload-svg{
        // width: 10px;
        // height: 10px;
        // display: inline-block;
        // vertical-align: -2px!important;
        // margin-right: 2px;
        stroke:#2473E8;
        color:#2473E8;
    }
    .processing-svg{
        width: 10px;
        height: 10px;
        display: inline-block;
        vertical-align: -2px!important;
        margin-right: 2px;
        color:#61e2ff;
    }
    .failed-svg{
        width: 10px;
        height: 10px;
        display: inline-block;
        vertical-align: -2px!important;
        margin-right: 2px;
        color:#ff7b7b;
    }
    .waiting-svg{
        width: 10px;
        height: 10px;
        display: inline-block;
        vertical-align: -1px!important;
        margin-right: 2px;
        color:#fff;
    }
    .add-svg{
        width: 17px;
        height: 17px;
        vertical-align: -3px!important;
        margin-right: 8px;
        color:#fff;
    }
    .icon-svg{
        width: 24px;
        height: 24px;
        display: inline-block;
        vertical-align: -8px!important;
        margin-right: 6px;
        color:#2473e8;
    }
    
    .tip-svg{
        width: 70px;
        height: 70px;
        color:#2473E8;
        stroke:#2473E8
    }
    .previous-svg{
        width: 20px;
        height: 20px;
        stroke:#555555;
    }
    .upgrade-s-svg{
        width: 24px;
        height: 25px;
        margin-right: 16px;
        color:#FF9E44;
    }
    .history-svg{
        width: 24px;
        height: 25px;
        margin-right: 16px;
        color:#2473E8;
    }
    .no_watermark{
        position: absolute;
        left: 50%;
        bottom: -5%;
        transform: translateX(-50%);
        white-space: nowrap;
        color: #999;
    }
    .save-cancel{
        background: rgba(208,208,208,0.1)!important;
        border: 1px solid #D0D0D0!important;
        color: #D0D0D0!important;
        cursor: no-drop!important;
        &:hover{
            background: rgba(208,208,208,0.1)!important;
            border: 1px solid #D0D0D0!important;
            color: #D0D0D0!important;
            cursor: no-drop!important;
        }
    }
    .imgbg{
        background: url(../assets/bg.jpg);
        // height: 95%!important;
        // width: auto!important;
    }
    .uploadBox{
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%,-50%);
        border: 2px dashed $btn_bg;
        border-radius: 16px;
        max-width: 552px;
        width: 95%;
        text-align: center;
        padding-top: 48px;
        padding-bottom: 64px;
        text-align: center;
        img{
            margin: auto;
        }
        .upload-svg{
            display: block;
            margin: auto;
            width: 80px;
            height: 80px;
        }
        label{
            min-width: 220px;
            padding-left: 10px;
            padding-right: 10px;
            line-height: 56px;
            font-size: 18px;
            font-weight: 500;
            color: #fff;
            background: $btn_bg;
            border-radius: 8px;
            display: inline-block;
            margin-top: 8px;
            cursor: pointer;
        }
        label:hover{
            background: $btn_bg_h;
        }
        p{
            font-size: 16px;
            color: #000;
            line-height: 20px;
            margin-top: 16px;
        }
    }
    .editor{
        min-width: 1350px;
        position: absolute;
        left: 0px;
        top: 56px;
        width: 100%;
        height: calc(100% - 56px);
        padding: 42px 24px 80px;
        box-sizing: border-box;
        overflow: hidden!important;
        
        >.left{
            max-width: 200px;
            width: 100%;
            height: 100%;
            label{
                width: 200px;
                height: 36px;
                line-height: 36px;
                background: $btn_bg;
                color: #fff;
                font-size: 16px;
                display: inline-block;
                text-align: center;
                border-radius: 4px;
                cursor: pointer;
                i{
                    width: 17px;
                    height: 17px;
                    // background: url(../assets/add.svg);
                    vertical-align: -3px;
                    margin-right: 8px;
                }
            }
            label:hover{
                background: $btn_bg_h;
            }
            >div{
                box-sizing: border-box;
                box-shadow: 0px 2px 12px 0px rgba(166,166,166,0.3);
                border-radius: 4px 4px 4px 4px;
                margin-top: 20px;
                padding-right: 3px;
                height: auto;
                height: calc(100% - 56px);
                overflow: auto;
            }
            >div::-webkit-scrollbar{
                width: 4px;
            }
            >div::-webkit-scrollbar-thumb{
                background: #808080;
                border-radius: 4px;
            }
            ul{
                display: block;
                padding:10px 10px 20px;
                li{
                    position: relative;
                    margin-bottom: 12px;
                    .img{
                        width: 140px;
                        height: 86px;
                        position: relative;
                        background: #000;
                        background-size: contain;
                        background-position: center center;
                        background-repeat: no-repeat;
                    }
                    .state{
                        position: absolute;
                        left: 0px;
                        top: 0px;
                        z-index: 1;
                        padding: 0px 14px 0px 6px;
                        background: rgba(12, 22, 26, 1);
                        i{
                            width: 10px;
                            height: 10px;
                            display: inline-block;
                            margin-right: 2px;
                        }
                        span{
                            font-size: 12px;
                        }
                    }
                    .state.completed{
                        // i{
                        //     background: url(../assets/completed.svg);
                        //     vertical-align: -2px;
                        // }
                        span{color: #3CDC99;}
                    }
                    .state.processing{
                        // i{
                        //     background: url(../assets/processing.svg);
                        //     vertical-align: -1px;
                        // }
                        span{color: #61E3FF;}
                    }
                    .state.failed{
                        // i{
                        //     background: url(../assets/failed.svg);
                        //     vertical-align: -2px;
                        // }
                        span{color: #FF7B7B;}
                    }
                    .state.waiting{
                        // i{
                        //     background: url(../assets/waiting.svg);
                        //     vertical-align: -1px;
                        // }
                        span{color: #FFFFFF;}
                    }
                    .state.upload{
                        span{color: #fff;}
                    }
                    >.li-right>i{
                        width: 15px;
                        height: 15px;
                        position: absolute;
                        right: 10px;
                        cursor: pointer;
                    }
                    // i.close{
                    //     background: url(../assets/close.svg);
                    //     top: 18px;
                    //     &:hover{
                    //         background: url(../assets/close-h1.svg);
                    //     }
                    // }
                    .down-svg{
                        width: 15px;
                        height: 15px;
                        position: absolute;
                        right: 10px;
                        cursor: pointer;
                        color:#555;
                        top: 18px;
                        &:hover{
                        color:#2473E8;
                        }
                    }
                    .close-svg{
                        width: 15px;
                        height: 15px;
                        position: absolute;
                        right: 10px;
                        cursor: pointer;
                        color:#555;
                        top: 18px;
                        &:hover{
                        color:#2473E8;
                        }
                    }
                    .delect-svg{
                        width: 15px;
                        height: 15px;
                        position: absolute;
                        right: 10px;
                        cursor: pointer;
                        bottom: 18px;
                        color:#555;
                        &:hover{
                        color:#2473E8;
                        }
                    }
                    // i.delect{
                    //     background: url(../assets/delect.svg);
                    //     bottom: 18px;
                    //     &:hover{
                    //         background: url(../assets/delect-h.svg);
                    //     }
                    // }
                    // i.down{
                    //     background: url(../assets/down.svg);
                    //     top: 18px;
                    //     &:hover{
                    //         background: url(../assets/down-h.svg);
                    //     }
                    // }
                }
                li:last-child{
                    margin-bottom: 0px;
                }
            }
        }
        >.right{
            flex: 1;
            margin-left: 58px;
            >.top{
                align-items: center;
                .multiple{
                    padding: 18px 58px;
                    box-shadow: 0px 2px 12px 0px rgba(166,166,166,0.3);
                    border-radius: 8px 8px 8px 8px;
                    span:first-child{
                        margin-right: 16px;
                    }
                    .multiple_num:last-child{
                        margin-right: 0px;
                    }
                    .multiple_num{
                        min-width: 80px;
                        height: 32px;
                        line-height: 30px;
                        border: 1px solid #cfcfcf;
                        font-size: 16px;
                        color: #333;
                        text-align: center;
                        display: inline-block;
                        border-radius: 4px;
                        margin-right: 10px;
                        box-sizing: border-box;
                    }
                    .multiple_num:hover{
                        background: $btn_bg;
                        border-color: $btn_bg;
                        color: #fff;
                        cursor: pointer;
                    }
                }
                .btn{
                    span{
                        display: inline-block;
                        min-width: 130px;
                        height: 36px;
                        line-height: 34px;
                        box-sizing: border-box;
                        border: 1px solid $btn_bg;
                        text-align: center;
                        border-radius: 4px;
                        color: #fff;
                        cursor: pointer;
                    }
                    span:first-child{
                        background: $btn_bg;
                    }
                    span:last-child{
                        margin-left: 16px;
                        color: $btn_bg;
                    }
                    span:hover{
                        background: $btn_bg_h;
                        border-color: $btn_bg_h;
                        color: #fff;
                    }
                }
            }
            >.img_box{
                margin-top: 42px;
                height: calc(100% - 44px - 68px);
                >div.left{
                    z-index: 2;
                    // overflow: auto;
                    // height: 100%;
                }
                >div.right{
                    z-index: 1;
                    // overflow: auto;
                    // height: 95%;
                }
                >div{
                    width: 49%;
                    height: 95%;
                    position: relative;
                    >div{
                        position: absolute;
                        left: 50%;
                        top: 50%;
                        transform: translate(-50%,-50%);
                    }
                    img{
                        position: relative;
                        z-index: -1;
                    }
                    .mask{
                        background: #fff;
                        opacity: .7;
                        position: absolute;
                        width: 200px;
                        height: 200px;
                    }
                    .preview{
                        width: 200px;
                        height: 200px;
                        position: absolute;
                        z-index: 3;
                        background-repeat: no-repeat;
                    }
                    .imgMask{
                        width: 100%;
                        height: 100%;
                        position: absolute;
                        left: 0;
                        top: 0;
                    }
                    .tips{
                        background: #F5F9FF;
                        text-align: center;
                        width: 100%;
                        height: 100%;
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        align-items: center;
                        position: relative;
                        z-index: 4;
                        img{
                            z-index: 1;
                            margin: 0px auto 10px;
                            width: 100px;
                        }
                        .error-svg{
                            z-index: 1;
                            margin: 0px auto 10px;
                            color:#FF7979;
                            width: 100px;
                            height: 100px;
                        }
                        p{
                            font-size: 24px;
                            color: #1e1e1e;
                            line-height: 28px;
                        }
                    }
                }
                >i{
                    height: 100%;
                    width: 1px;
                    background: #D8D8D8;
                }
            }
            >.bottom{
                border-top: 1px solid #D8D8D8;
                padding-top: 10px;
                display: flex;
                >span{
                    width: 160px;
                    margin-top: 5px;
                    font-size: 14px;
                    line-height: 28px;
                    color: #333;
                }
                >span:last-child{text-align: right;}
                // >i{
                //     width: 13px;
                //     height: 13px;
                //     background: url(../assets/img-change.svg);
                //     cursor: pointer;
                // }
            }
        }
        // .active{
        //     background: $btn_bg!important;
        //     border-color: $btn_bg!important;
        //     color: #fff!important;
        //     cursor: pointer!important;
        // }
    }
    .active{
        background: $btn_bg!important;
        border-color: $btn_bg!important;
        color: #fff!important;
        cursor: pointer!important;
    }
    .maskTips{
        position: fixed;
        top: 0px;
        left: 0px;
        width: 100%;
        height: 100%;
        background: rgba(0,0,0,.4);
        z-index: 9;
        // display: none;
        >div{
            background: #fff;
            box-shadow: 0px 6px 13px -4px rgba(0,0,0,0.5);
            border-radius: 16px;
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%,-50%);
            max-width: 730px;
            width: 100%;
            padding: 30px 40px 50px;
            box-sizing: border-box;
            text-align: center;
            .close{
                width: 20px;
                height: 20px;
                // background: url(../assets/close-m.svg) no-repeat center center/cover;
                position: absolute;
                top: 16px;
                right: 16px;
                cursor: pointer;
            }
            
            >img{
                display: block;
                margin: auto;
            }
            >p{
                font-size: 16px;
                color: #333;
                line-height: 28px;
                margin-top: 26px;
                margin-bottom: 30px;
            }
            .title{
                font-weight: bold;
                margin-bottom: 15px;
            }
            .btn{
                display: inline-block;
                border-radius: 6px;
                min-width: 406px;
                cursor: pointer;
                text-decoration: none;
            }
            .btn_v1{
                background: $btn_bg;
                color: #fff;
                line-height: 34px;
            }
            .btn_v1:hover{
                background: $btn_bg;
            }
            .btn_v2{
                line-height: 32px;
                border: 1px solid #979797;
                box-sizing: border-box;
                margin-top: 20px;
            }
            .errorList::-webkit-scrollbar{
                width: 4px;
            }
            .errorList::-webkit-scrollbar-thumb{
                background:rgba(0,0,0,.5);
                border-radius: 4px;
            }
            .errorList{
                max-height: 350px;
                overflow: auto;
                text-align: left;
                margin-bottom: 30px;
                // border: 1px solid #F1F8FF;
                margin-top: 20px;
                >div{
                    width: 100%;
                    height: 70px;
                    border-bottom: 1px solid #F1F8FF;
                    display: flex;
                    align-items: center;
                    >span{
                        width: 50%;
                        display: inline-block;
                        padding-left: 34px;
                        box-sizing: border-box;
                        vertical-align: middle;
                        color: #FE6363;
                        font-weight: normal;
                    }
                    .left{
                        padding-left: 34px;
                        display: flex;
                        align-items: center;
                        width: 50%;
                        box-sizing: border-box;
                        i{
                            width: 88px;
                            height: 52px;
                            position: relative;
                            background: #000;
                            background-size: contain;
                            background-position: center center;
                            background-repeat: no-repeat;
                        }
                        span{
                            font-weight: normal;
                            font-size: 16px;
                            color: #333;
                            margin-left: 6px;
                        }
                    }
                }
                >div:nth-child(1){
                    background: #F1F8FF;
                    span{
                        font-size: 16px;
                        font-weight: bold;
                        color: #333;
                    }
                }
                >div:last-child{
                    border-bottom: none;
                }
                .multiple{
                    // padding: 18px 58px;
                    // box-shadow: 0px 2px 12px 0px rgba(166,166,166,0.3);
                    border-radius: 8px 8px 8px 8px;
                    span:first-child{
                        margin-right: 16px;
                    }
                    .multiple_num:last-child{
                        margin-right: 0px;
                    }
                    .multiple_num{
                        min-width: 80px;
                        height: 32px;
                        line-height: 30px;
                        border: 1px solid #cfcfcf;
                        font-size: 16px;
                        color: #333;
                        text-align: center;
                        display: inline-block;
                        border-radius: 4px;
                        margin-right: 10px;
                        box-sizing: border-box;
                        padding-left:0px;
                    }
                    .multiple_num:hover{
                        background: $btn_bg;
                        border-color: $btn_bg;
                        color: #fff;
                        cursor: pointer;
                    }
                }
            }
        }
    }
    .mobiletop{
        display: none;
    }
    .mobilebottom{
        display: none;
    }
    .right-bottom{
        display: none;
    }
    @media(max-width:1024px) {
        .no_watermark{
            display: none!important;;
        }
        .maskTips{
            
            >div{
                width: 90%;
                .btn{
                    // display: inline-block;
                    // border-radius: 6px;
                    min-width: 80%;
                    // cursor: pointer;
                }
                .errorList{
                    margin-top: 20px;
                    .multiple{
                    // padding: 18px 58px;
                    // box-shadow: 0px 2px 12px 0px rgba(166,166,166,0.3);
                    border-radius: 8px 8px 8px 8px;
                    span:first-child{
                        margin-right: 7px;
                    }
                    .multiple_num:last-child{
                        margin-right: 0px;
                    }
                    .multiple_num{
                        min-width: 60px;
                        height: 32px;
                        line-height: 30px;
                        border: 1px solid #cfcfcf;
                        font-size: 0.8rem;
                        color: #333;
                        text-align: center;
                        display: inline-block;
                        border-radius: 4px;
                        margin-right: 7px;
                        box-sizing: border-box;
                        padding-left:0px;
                    }
                    .multiple_num:hover{
                        background: $btn_bg;
                        border-color: $btn_bg;
                        color: #fff;
                        cursor: pointer;
                    }
                }
                }
            }
        }
        .mobiletop{
            background: #FAFAFA;
            height: 52px;
            padding-left: 40px;
            padding-right: 40px;
            box-sizing: border-box;
            display: flex;
            align-items: center;
            color:#2473E8;
            .icon-list-open{
                display: inline-block;
                width: 24px;
                height: 24px;
                color:#555555;
            }
            .icon-mobile-add{
                margin: 0 8px 0 24px;
                display: inline-block;
                width: 24px;
                height: 24px;
                stroke:#2473E8;
                fill: #2473E8;
            }
        }
        .editor{
            min-width: 100%;
            position: absolute;
            left: 0px;
            top: 124px;
            width: 100%;
            // height: calc(100% - 56px);
            height: 100%;
            padding: 0px 40px 0px;
            box-sizing: border-box;
            // overflow: hidden;
            overflow-y: auto;
            height: calc(100% - 176px);
            >.left{
                max-width: 100%;
                width: 100%;
                height: 100%;
                label{
                    display: none;
                }
                >div{
                    box-sizing: border-box;
                    box-shadow: unset;
                    border-radius: 4px 4px 4px 4px;
                    margin-top: 0px;
                    padding-right: 3px;
                    height: auto;
                    // height: calc(100% - 176px);
                    // overflow: auto;
                }
                >div::-webkit-scrollbar{
                    width: 4px;
                }
                >div::-webkit-scrollbar-thumb{
                    background: #808080;
                    border-radius: 4px;
                }
                ul{
                    display: block;
                    padding:8px 0px 20px;
                    li{
                        position: relative;
                        padding: 16px 0;
                        margin-bottom: 0px;
                        border-bottom: 1px solid #F3f3f3;
                        .img{
                            width: 140px;
                            height: 86px;
                            position: relative;
                            background: #000;
                            background-size: contain;
                            background-position: center center;
                            background-repeat: no-repeat;
                        }
                        .state{
                            position: absolute;
                            left: 0px;
                            top: 16px;
                            z-index: 1;
                            padding: 0px 14px 0px 6px;
                            background: rgba(12, 22, 26, 1);
                            i{
                                width: 10px;
                                height: 10px;
                                display: inline-block;
                                margin-right: 2px;
                            }
                            span{
                                font-size: 12px;
                            }
                        }
                        // .state.completed{
                        //     i{
                        //         background: url(../assets/completed.svg);
                        //         vertical-align: -2px;
                        //     }
                        //     span{color: #3CDC99;}
                        // }
                        // .state.processing{
                        //     i{
                        //         background: url(../assets/processing.svg);
                        //         vertical-align: -1px;
                        //     }
                        //     span{color: #61E3FF;}
                        // }
                        // .state.failed{
                        //     i{
                        //         background: url(../assets/failed.svg);
                        //         vertical-align: -2px;
                        //     }
                        //     span{color: #FF7B7B;}
                        // }
                        // .state.waiting{
                        //     i{
                        //         background: url(../assets/waiting.svg);
                        //         vertical-align: -1px;
                        //     }
                        //     span{color: #FFFFFF;}
                        // }
                        .state.upload{
                            span{color: #fff;}
                        }
                        >.li-right{
                            display: flex;
                            // float: right;
                            position: absolute;
                            right: 0;
                            top: 50%;
                            bottom: 50%;
                            flex-direction: row;
                            align-items: center;
                            width: 100px;
                            justify-content: flex-end;
                            >i{
                                width: 15px;
                                height: 15px;
                                position: relative;
                                right: 20px;
                                cursor: pointer;
                            }
                            // i.close{
                            //     background: url(../assets/close.svg);
                            //     top: 0px!important;
                            //     &:hover{
                            //         background: url(../assets/close-h1.svg);
                            //     }
                            // }
                            // i.delect{
                            //     background: url(../assets/delect.svg);
                            //     bottom: 0px;
                            //     right: 0px;
                            //     &:hover{
                            //         background: url(../assets/delect-h.svg);
                            //     }
                            // }
                            // i.down{
                            //     background: url(../assets/down.svg);
                            //     top: 0px;
                            //     &:hover{
                            //         background: url(../assets/down-h.svg);
                            //     }
                            // }
                            .down-svg{
                                width: 15px;
                                height: 15px;
                                position: relative;
                                right: 20px;
                                cursor: pointer;
                                color:#555;
                                top: 0px;
                                &:hover{
                                color:#2473E8;
                                }
                            }
                            .close-svg{
                                width: 15px;
                                height: 15px;
                                position: relative;
                                right: 10px;
                                cursor: pointer;
                                color:#555;
                                top: 0px!important;
                                &:hover{
                                color:#2473E8;
                                }
                            }
                            .delect-svg{
                                width: 15px;
                                height: 15px;
                                position: relative;
                                // right: 10px;
                                cursor: pointer;
                                bottom: 0px;
                                right: 0px;
                                color:#555;
                                &:hover{
                                color:#2473E8;
                                }
                            }
                        }
                    }
                    li:last-child{
                        margin-bottom: 0px;
                    }
                }
            }
            >.right{
                flex: 1;
                margin-left: 0px;
                // display: none;
                height: 300px;
                >.top{
                    align-items: center;
                    justify-content: center;
                    .multiple{
                        padding: 18px 0px;
                        box-shadow: unset;
                        border-radius: 8px 8px 8px 8px;
                        width: 100%;
                        text-align: center;
                        span:first-child{
                            margin-right: 16px;
                            font-size: 0.8rem;
                        }
                        .multiple_num:last-child{
                            margin-right: 0px;
                        }
                        .multiple_num{
                            min-width: 18%;
                            height: 28px;
                            line-height: 26px;
                            border: 1px solid #cfcfcf;
                            font-size: 0.9rem;
                            color: #333;
                            text-align: center;
                            display: inline-block;
                            border-radius: 4px;
                            margin-right: 10px;
                            box-sizing: border-box;
                        }
                        .multiple_num:hover{
                            background: $btn_bg;
                            border-color: $btn_bg;
                            color: #fff;
                            cursor: pointer;
                        }
                    }
                    .btn{
                        display: none;
                        span{
                            display: inline-block;
                            min-width: 130px;
                            height: 36px;
                            line-height: 34px;
                            box-sizing: border-box;
                            border: 1px solid $btn_bg;
                            text-align: center;
                            border-radius: 4px;
                            color: #fff;
                            cursor: pointer;
                        }
                        span:first-child{
                            background: $btn_bg;
                        }
                        span:last-child{
                            margin-left: 16px;
                            color: $btn_bg;
                        }
                        span:hover{
                            background: $btn_bg_h;
                            border-color: $btn_bg_h;
                            color: #fff;
                        }
                    }
                }
                >.img_box{
                    margin-top: 16px;
                    // height: calc(100% - 44px - 68px);
                    height: 100%;
                    >div.left{
                        z-index: 2;
                        // display: none;
                        // opacity: 0;
                    }
                    >div.right{
                        z-index: 1;
                        // width: 99%;
                    }
                    >div{
                        width: 49%;
                        height: 95%;
                        position: relative;
                        >div{
                            position: absolute;
                            left: 50%;
                            top: 50%;
                            transform: translate(-50%,-50%);
                        }
                        img{
                            position: relative;
                            z-index: -1;
                        }
                        .mask{
                            background: #fff;
                            opacity: .7;
                            position: absolute;
                            width: 200px;
                            height: 200px;
                        }
                        .preview{
                            width: 200px;
                            height: 200px;
                            position: absolute;
                            z-index: 3;
                            background-repeat: no-repeat;
                        }
                        .imgMask{
                            width: 100%;
                            height: 100%;
                            position: absolute;
                            left: 0;
                            top: 0;
                            display: none;
                        }
                        .tips{
                            background: #F5F9FF;
                            text-align: center;
                            width: 100%;
                            height: 100%;
                            display: flex;
                            flex-direction: column;
                            justify-content: center;
                            align-items: center;
                            position: relative;
                            z-index: 4;
                            img{
                                z-index: 1;
                                margin: 0px auto 10px;
                                // width: 36px;
                            }
                            .error-svg{
                                z-index: 1;
                                margin: 0px auto 10px;
                                color:#FF7979;
                            }
                            p{
                                font-size: 16px;
                                color: #1e1e1e;
                                line-height: 28px;
                            }
                        }
                    }
                    >i{
                        height: 100%;
                        width: 1px;
                        background: #D8D8D8;
                    }
                }
                >.bottom{
                    border-top: 1px solid #D8D8D8;
                    padding-top: 10px;
                    >span{
                        width: 160px;
                        margin-top: 5px;
                        font-size: 14px;
                        line-height: 28px;
                        color: #333;
                    }
                    >span:last-child{text-align: right;}
                    // >i{
                    //     width: 13px;
                    //     height: 13px;
                    //     background: url(../assets/img-change.svg);
                    //     cursor: pointer;
                    // }
                }
                >.right-bottom{
                        padding: 24px 34px;
                        display: flex;
                        justify-content: center;
                        width: 50%;
                        margin: auto;
                    >p{
                        min-width: 120px;
                        height: 28px;
                        background: #EBF3FF;
                        border-radius: 38px 38px 38px 38px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        &:last-child{
                            margin-left: 24px;
                        }
                    }
                }
            }
            .active{
                background: $btn_bg!important;
                border-color: $btn_bg!important;
                color: #fff!important;
                cursor: pointer!important;
            }
        }

        .mobilebottom{
            height: 52px;
            background: #F5F9FF;
            position: fixed;
            bottom: 0;
            width: 100%;
            z-index: 9999999;
            padding-left: 40px;
            padding-right: 40px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            box-sizing: border-box;
            .left{
                display: flex;
                img{
                    margin-right: 16px;
                }
            }
            .right{
                span{
                    display: inline-block;
                    min-width: 100px;
                    height: 28px;
                    line-height: 26px;
                    box-sizing: border-box;
                    border: 1px solid #2473E8;
                    text-align: center;
                    border-radius: 4px;
                    color: #fff;
                }
                span:first-child{
                    background: $btn_bg;
                }
                span:last-child{
                    margin-left: 16px;
                    color: $btn_bg;
                }
            }
        }
        .show{
            position: absolute;
            left: 10000px;
        }
    }
    @media(max-width:480px) {
        .no_watermark{
            display: none!important;;
        }
        .maskTips{
            
            >div{
                width: 90%;
                .btn{
                    // display: inline-block;
                    // border-radius: 6px;
                    min-width: 80%;
                    // cursor: pointer;
                }
                .errorList{
                    margin-top: 20px;
                    .multiple{
                    // padding: 18px 58px;
                    // box-shadow: 0px 2px 12px 0px rgba(166,166,166,0.3);
                    border-radius: 8px 8px 8px 8px;
                    span:first-child{
                        margin-right: 7px;
                    }
                    .multiple_num:last-child{
                        margin-right: 0px;
                    }
                    .multiple_num{
                        min-width: 60px;
                        height: 32px;
                        line-height: 30px;
                        border: 1px solid #cfcfcf;
                        font-size: 0.8rem;
                        color: #333;
                        text-align: center;
                        display: inline-block;
                        border-radius: 4px;
                        margin-right: 7px;
                        box-sizing: border-box;
                        padding-left:0px;
                    }
                    .multiple_num:hover{
                        background: $btn_bg;
                        border-color: $btn_bg;
                        color: #fff;
                        cursor: pointer;
                    }
                }
                }
            }
        }
        .mobiletop{
            background: #FAFAFA;
            height: 52px;
            padding-left: 24px;
            padding-right: 24px;
            box-sizing: border-box;
            display: flex;
            align-items: center;
            color:#2473E8;
            .icon-list-open{
                display: inline-block;
                width: 24px;
                height: 24px;
                color:#555555;
            }
            .icon-mobile-add{
                margin: 0 8px 0 24px;
                display: inline-block;
                width: 24px;
                height: 24px;
                stroke:#2473E8;
                fill: #2473E8;
            }
        }
        .editor{
            min-width: 100%;
            position: absolute;
            left: 0px;
            top: 124px;
            width: 100%;
            // height: calc(100% - 56px);
            height: 100%;
            padding: 0px 24px 0px;
            box-sizing: border-box;
            // overflow: hidden;
            overflow-y: auto;
            height: calc(100% - 176px);
            >.left{
                max-width: 100%;
                width: 100%;
                height: 100%;
                label{
                    display: none;
                }
                >div{
                    box-sizing: border-box;
                    box-shadow: unset;
                    border-radius: 4px 4px 4px 4px;
                    margin-top: 0px;
                    padding-right: 3px;
                    height: auto;
                    // height: calc(100% - 176px);
                    // overflow: auto;
                }
                >div::-webkit-scrollbar{
                    width: 4px;
                }
                >div::-webkit-scrollbar-thumb{
                    background: #808080;
                    border-radius: 4px;
                }
                ul{
                    display: block;
                    padding:8px 0px 20px;
                    li{
                        position: relative;
                        padding: 16px 0;
                        margin-bottom: 0px;
                        border-bottom: 1px solid #F3f3f3;
                        .img{
                            width: 140px;
                            height: 86px;
                            position: relative;
                            background: #000;
                            background-size: contain;
                            background-position: center center;
                            background-repeat: no-repeat;
                        }
                        .state{
                            position: absolute;
                            left: 0px;
                            top: 16px;
                            z-index: 1;
                            padding: 0px 14px 0px 6px;
                            background: rgba(12, 22, 26, 1);
                            i{
                                width: 10px;
                                height: 10px;
                                display: inline-block;
                                margin-right: 2px;
                            }
                            span{
                                font-size: 12px;
                            }
                        }
                        // .state.completed{
                        //     i{
                        //         background: url(../assets/completed.svg);
                        //         vertical-align: -2px;
                        //     }
                        //     span{color: #3CDC99;}
                        // }
                        // .state.processing{
                        //     i{
                        //         background: url(../assets/processing.svg);
                        //         vertical-align: -1px;
                        //     }
                        //     span{color: #61E3FF;}
                        // }
                        // .state.failed{
                        //     i{
                        //         background: url(../assets/failed.svg);
                        //         vertical-align: -2px;
                        //     }
                        //     span{color: #FF7B7B;}
                        // }
                        // .state.waiting{
                        //     i{
                        //         background: url(../assets/waiting.svg);
                        //         vertical-align: -1px;
                        //     }
                        //     span{color: #FFFFFF;}
                        // }
                        .state.upload{
                            span{color: #fff;}
                        }
                        >.li-right{
                            display: flex;
                            // float: right;
                            position: absolute;
                            right: 0;
                            top: 50%;
                            bottom: 50%;
                            flex-direction: row;
                            align-items: center;
                            width: 100px;
                            justify-content: flex-end;
                            >i{
                                width: 15px;
                                height: 15px;
                                position: relative;
                                right: 20px;
                                cursor: pointer;
                            }
                            // i.close{
                            //     background: url(../assets/close.svg);
                            //     top: 0px!important;
                            //     &:hover{
                            //         background: url(../assets/close-h1.svg);
                            //     }
                            // }
                            // i.delect{
                            //     background: url(../assets/delect.svg);
                            //     bottom: 0px;
                            //     right: 0px;
                            //     &:hover{
                            //         background: url(../assets/delect-h.svg);
                            //     }
                            // }
                            // i.down{
                            //     background: url(../assets/down.svg);
                            //     top: 0px;
                            //     &:hover{
                            //         background: url(../assets/down-h.svg);
                            //     }
                            // }
                        }
                    }
                    li:last-child{
                        margin-bottom: 0px;
                    }
                }
            }
            >.right{
                flex: 1;
                margin-left: 0px;
                // display: none;
                height: 150px;
                >.top{
                    align-items: center;
                    justify-content: center;
                    .multiple{
                        padding: 18px 0px;
                        box-shadow: unset;
                        border-radius: 8px 8px 8px 8px;
                        span:first-child{
                            margin-right: 10px;
                            font-size: 0.8rem;
                        }
                        .multiple_num:last-child{
                            margin-right: 0px;
                        }
                        .multiple_num{
                            min-width: 54px;
                            height: 28px;
                            line-height: 26px;
                            border: 1px solid #cfcfcf;
                            font-size: 0.8rem;
                            color: #333;
                            text-align: center;
                            display: inline-block;
                            border-radius: 4px;
                            margin-right: 10px;
                            box-sizing: border-box;
                            >i{
                                display: none;
                            }
                        }
                        .multiple_num:hover{
                            background: $btn_bg;
                            border-color: $btn_bg;
                            color: #fff;
                            cursor: pointer;
                        }
                    }
                    .btn{
                        display: none;
                        span{
                            display: inline-block;
                            min-width: 130px;
                            height: 36px;
                            line-height: 34px;
                            box-sizing: border-box;
                            border: 1px solid $btn_bg;
                            text-align: center;
                            border-radius: 4px;
                            color: #fff;
                            cursor: pointer;
                        }
                        span:first-child{
                            background: $btn_bg;
                        }
                        span:last-child{
                            margin-left: 16px;
                            color: $btn_bg;
                        }
                        span:hover{
                            background: $btn_bg_h;
                            border-color: $btn_bg_h;
                            color: #fff;
                        }
                    }
                }
                >.img_box{
                    margin-top: 16px;
                    // height: calc(100% - 44px - 68px);
                    height: 100%;
                    >div.left{
                        z-index: 2;
                        // display: none;
                        // opacity: 0;
                    }
                    >div.right{
                        z-index: 1;
                        // width: 99%;
                    }
                    >div{
                        width: 49%;
                        height: 95%;
                        position: relative;
                        >div{
                            position: absolute;
                            left: 50%;
                            top: 50%;
                            transform: translate(-50%,-50%);
                        }
                        img{
                            position: relative;
                            z-index: -1;
                        }
                        .mask{
                            background: #fff;
                            opacity: .7;
                            position: absolute;
                            width: 200px;
                            height: 200px;
                        }
                        .preview{
                            width: 200px;
                            height: 200px;
                            position: absolute;
                            z-index: 3;
                            background-repeat: no-repeat;
                        }
                        .imgMask{
                            width: 100%;
                            height: 100%;
                            position: absolute;
                            left: 0;
                            top: 0;
                            display: none;
                        }
                        .tips{
                            background: #F5F9FF;
                            text-align: center;
                            width: 100%;
                            height: 100%;
                            display: flex;
                            flex-direction: column;
                            justify-content: center;
                            align-items: center;
                            position: relative;
                            z-index: 4;
                            img{
                                z-index: 1;
                                margin: 0px auto 10px;
                                width: 36px;
                            }
                            .error-svg{
                                z-index: 1;
                                margin: 0px auto 10px;
                                color:#FF7979;
                                width: 36px;
                                height: 36px;
                            }
                            p{
                                font-size: 12px;
                                color: #1e1e1e;
                                line-height: 15px;
                            }
                        }
                    }
                    >i{
                        height: 100%;
                        width: 1px;
                        background: #D8D8D8;
                    }
                }
                >.bottom{
                    border-top: 1px solid #D8D8D8;
                    padding-top: 10px;
                    >span{
                        width: 160px;
                        margin-top: 5px;
                        font-size: 14px;
                        line-height: 28px;
                        color: #333;
                    }
                    >span:last-child{text-align: right;}
                    // >i{
                    //     width: 13px;
                    //     height: 13px;
                    //     background: url(../assets/img-change.svg);
                    //     cursor: pointer;
                    // }
                }
                >.right-bottom{
                        padding: 24px 34px;
                        display: flex;
                        justify-content: center;
                        // width: auto;
                    >p{
                        min-width: 120px;
                        height: 28px;
                        background: #EBF3FF;
                        border-radius: 38px 38px 38px 38px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        &:last-child{
                            margin-left: 24px;
                        }
                    }
                }
            }
            .active{
                background: $btn_bg!important;
                border-color: $btn_bg!important;
                color: #fff!important;
                cursor: pointer!important;
            }
        }

        .mobilebottom{
            height: 52px;
            background: #F5F9FF;
            position: fixed;
            bottom: 0;
            width: 100%;
            z-index: 9999999;
            padding-left: 24px;
            padding-right: 24px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            box-sizing: border-box;
            .left{
                display: flex;
                img{
                    margin-right: 16px;
                }
            }
            .right{
                span{
                    display: inline-block;
                    min-width: 100px;
                    height: 28px;
                    line-height: 26px;
                    box-sizing: border-box;
                    border: 1px solid #2473E8;
                    text-align: center;
                    border-radius: 4px;
                    color: #fff;
                }
                span:first-child{
                    background: $btn_bg;
                }
                span:last-child{
                    margin-left: 16px;
                    color: $btn_bg;
                }
            }
        }
        .show{
            position: absolute;
            left: 10000px;
        }
    }

    .icon-box {
        position: absolute;
        top: 10px;
        left: 15px;
    }

     .icon-box img {
        width: 24px;
        height: 24px;
        display: inline-block;
        vertical-align: -8px;
        margin-right: 6px;
    }

     .icon-box .icon-text {
        display: inline-block;
        vertical-align: middle;
        color: #2757b7;
    }
    
</style>